/*------------------------------------------------------------------
[React]
-------------------------------------------------------------------*/
import React, {useEffect, useState, useRef } from "react";
/*------------------------------------------------------------------
[End React]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Helmet]
-------------------------------------------------------------------*/
import {Helmet} from "react-helmet";
/*------------------------------------------------------------------
[End React Helmet]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Router]
-------------------------------------------------------------------*/
import { useHistory, Link, NavLink } from "react-router-dom";
/*------------------------------------------------------------------
[End React Router]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Socket.io]
-------------------------------------------------------------------*/
import io from "socket.io-client";
/*------------------------------------------------------------------
[End Socket.io]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[API]
-------------------------------------------------------------------*/
import { API_GET_REQUEST, API_GET_URL, API_GET_PUBLIC, API_POST, API_URL, API_GET_GEO_PUBLIC, API_SERVER, API_SCT } from '../../../../../api';
/*------------------------------------------------------------------
[End API]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Module]
-------------------------------------------------------------------*/
import axios from 'axios'
import {reactLocalStorage} from 'reactjs-localstorage';
import {encode, decode} from 'html-entities'
import CurrencyFormat from 'react-currency-format';
import Tour from 'reactour'
import * as htmlToImage from 'html-to-image';
import { MapContainer, TileLayer, Marker, Popup, GeoJSON } from 'react-leaflet';
import { GoogleMap, LoadScript, Polyline } from '@react-google-maps/api';
import { MAP_STYLE_SILVER, MAP_STYLE_RETRO, MAP_STYLE_DARK, MAP_STYLE_NIGHT, MAP_STYLE_AUBERGINE, MAP_STYLE_BLACK_WHITE, MAP_STYLE_PAPER, MAP_STYLE_GOLDEN, MAP_STYLE_NETWORK } from "../../../../../data/map_style";

const Coordinates = require('coordinate-parser');
const utm = require('utm')
/*------------------------------------------------------------------
[End Module]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Functions]
-------------------------------------------------------------------*/
import { random_character, console_dev, getExtention } from '../../../../../functions'
/*------------------------------------------------------------------
[End Functions]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Etc]
-------------------------------------------------------------------*/
import OverlayBg from '../../../../../assets/img/overlay_bg_form.png'
/*------------------------------------------------------------------
[End Etc]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Veriable]
-------------------------------------------------------------------*/
let SOCKET_SERVER = process.env.REACT_APP_PRODUCTION === 'false' ? process.env.REACT_APP_SOCKET_SERVER_DEVELOPMENT : process.env.REACT_APP_SOCKET_SERVER_PRODUCTION;
let socket = io(SOCKET_SERVER);
/*------------------------------------------------------------------
[End Variable]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Screens]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[End Screens]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Components]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[End Components]
-------------------------------------------------------------------*/

const Screen = ({loading, error, progress}) => {

    /*--------------------------------------------------------------
    [History]
    ----------------------------------------------------------------*/
    const history = useHistory();
    /*--------------------------------------------------------------
    [End History]
    ----------------------------------------------------------------*/
    
    /*--------------------------------------------------------------
    [Storage]
    ----------------------------------------------------------------*/
    let STORAGE_TOKEN = reactLocalStorage.get('@token');
    let STORAGE_USER_STRINGIFY = reactLocalStorage.get('@user');

	let STORAGE_USER;

	if(STORAGE_USER_STRINGIFY){
		STORAGE_USER = JSON.parse(STORAGE_USER_STRINGIFY)
	}
    /*--------------------------------------------------------------
    [End Storage]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Meta]
    ----------------------------------------------------------------*/
    let meta_title = 'Tata Ruang';
    /*--------------------------------------------------------------
    [End Meta]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Request Params]
    ----------------------------------------------------------------*/
    let request_params = 'peta';
    /*--------------------------------------------------------------
    [End Request Params]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Pagination Offset]
    ----------------------------------------------------------------*/
    let pagination_offset = 20;
    /*--------------------------------------------------------------
    [End Pagination Offset]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [State]
    ----------------------------------------------------------------*/
    const [tour, set_tour] = useState(false);
    const [tab, set_tab] = useState(null);

    const [refresh, set_refresh] = useState(null);
    const [generate, set_generate] = useState(false);
    const [file, set_file] = useState(null);
    const [bamboo_user, set_bamboo_user] = useState(null);
    const [bamboo_update, set_bamboo_update] = useState('');
    const [bamboo_delete, set_bamboo_delete] = useState('');

    const [table_height, set_table_height] = useState(0);

    const [element, set_element] = useState(null);
    const [sub_element, set_sub_element] = useState(null);
    
    const [pagination_active, set_pagination_active] = useState(1);
    const [path_client, set_path_client] = useState('')
    const [data, set_data] = useState(null);
    const [data_check, set_data_check] = useState([])
    const [search, set_search] = useState('');
    /*--------------------------------------------------------------
    [End State]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [New State]
    ----------------------------------------------------------------*/
    const [test, set_test] = useState('')

    const [map_style, set_map_style] = useState([])
    const [map_type, set_map_type] = useState('roadmap')
    const [map_tata_ruang, set_map_tata_ruang] = useState(null)
    const [map_peta_dasar, set_map_peta_dasar] = useState(null)
    const [map_peta_tematik, set_map_peta_tematik] = useState(null)
    const [map_denah_warga, set_map_denah_warga] = useState(null)

    const [data_tata_ruang, set_data_tata_ruang] = useState(null)
    const [data_struktur_ruang, set_data_struktur_ruang] = useState(null)
    const [data_kawasan_strategis, set_data_kawasan_strategis] = useState(null)
    const [data_peta_dasar, set_data_peta_dasar] = useState(null)
    const [data_peta_tematik, set_data_peta_tematik] = useState(null)
    const [data_denah_warga, set_data_denah_warga] = useState(null)

    const [center_lat, set_center_lat] = useState(null)
    const [center_lng, set_center_lng] = useState(null)
    const [type, set_type] = useState(null)
    const [map_detail, set_map_detail] = useState(null)
    const [my_coordinate, set_my_coordinate] = useState(null)
    const [map_select, set_map_select] = useState(null)

    const [position, set_position] = useState({
        lat: '',
        lng: ''
    })

    const [coords_lat, set_coords_lat] = useState('')
    const [coords_lng, set_coords_lng] = useState('')

    const [search_coordinate_lat, set_search_coordinate_lat] = useState('')
    const [search_coordinate_lng, set_search_coordinate_lng] = useState('')
    const [search_coordinate_dms, set_search_coordinate_dms] = useState('')
    /*--------------------------------------------------------------
    [End New State]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Ref]
    ----------------------------------------------------------------*/
    const ref_table_height = useRef(null)
    const mapRef = useRef()
    /*--------------------------------------------------------------
    [End Ref]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Tour Guide]
    ----------------------------------------------------------------*/
    const steps = [
        {
          selector: '.___step_1',
          content: 'Content 1',
        },
    ];
    /*--------------------------------------------------------------
    [Tour Guide]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [API]
    ----------------------------------------------------------------*/
    const _search = () => {

        if(loading === true){
            return
        }
        
        if(search.length > 3){
    
            API_GET_REQUEST(`simpr/bprb/public/get__________?action=search_tata_ruang_denah_warga`
                + '&bamboo_user=' + bamboo_user
                + '&search=' + search
            , 
            ).then((response) => {
                console_dev(`response search_tata_ruang_denah_warga search`, response.data)
                if(response.data.result == 'success'){
                    set_data_denah_warga(response.data.data)
                    error('')
                }else if(response.data.error){
                    error(response.data.error);
                    set_data(null)
                }
            })
            .catch((e) => {
                console_dev('catch', e)
                error(e.message)
            }).finally(() => {
                loading(false)
            })

        }

    }

    const _read_tata_ruang = (pages, bambooUserParams) => {

        if(loading === true){
            return
        }
        
        loading(true);

        API_GET_PUBLIC(`simpr/bprb/peta/get/public__________?action=read_${request_params}_tata_ruang`
            // + '&bamboo_user=' + bambooUserParams
        , 
		).then((response) => {
            console_dev('response read', response.data)
            if(response.data.result == 'success'){
                set_data_tata_ruang(response.data.data)
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console_dev('catch', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

	}

    const _read_struktur_ruang = (pages, bambooUserParams) => {

        if(loading === true){
            return
        }
        
        loading(true);

        API_GET_PUBLIC(`simpr/bprb/peta/get/public__________?action=read_${request_params}_struktur_ruang`
            // + '&bamboo_user=' + bambooUserParams
        , 
		).then((response) => {
            console_dev('response read struktur ruang', response.data)
            if(response.data.result == 'success'){
                set_data_struktur_ruang(response.data.data)
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console_dev('catch', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

	}

    const _read_kawasan_strategis = (pages, bambooUserParams) => {

        if(loading === true){
            return
        }
        
        loading(true);

        API_GET_PUBLIC(`simpr/bprb/peta/get/public__________?action=read_${request_params}_kawasan_strategis`
            // + '&bamboo_user=' + bambooUserParams
        , 
		).then((response) => {
            console_dev('response read kawasan strategis', response.data)
            if(response.data.result == 'success'){
                set_data_kawasan_strategis(response.data.data)
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console_dev('catch', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

	}

    const _read_peta_dasar = (pages, bambooUserParams) => {

        if(loading === true){
            return
        }
        
        loading(true);

        API_GET_PUBLIC(`simpr/bprb/peta/get/public__________?action=read_${request_params}_dasar`
            // + '&bamboo_user=' + bambooUserParams
        , 
		).then((response) => {
            console_dev('response read peta dasar', response.data)
            if(response.data.result == 'success'){
                set_data_peta_dasar(response.data.data)
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console_dev('catch', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

	}

    const _read_peta_tematik = (pages, bambooUserParams) => {

        if(loading === true){
            return
        }
        
        loading(true);

        API_GET_PUBLIC(`simpr/bprb/peta/get/public__________?action=read_${request_params}_tematik`
            // + '&bamboo_user=' + bambooUserParams
        , 
		).then((response) => {
            console_dev('response read peta tematik', response.data)
            if(response.data.result == 'success'){
                set_data_peta_tematik(response.data.data)
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console_dev('catch', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

	}

    const _read_tata_ruang_map = (urlParams, typeParams) => {

        console_dev('url params --------- : ', urlParams)
        console_dev('type params -------- : ', typeParams)

        if(typeParams === 'geojson'){

            if(loading === true){
                return
            }
    
            loading(true);
            set_generate(true)
    
            API_GET_URL(urlParams)
            .then((response) => {
                console_dev('---------------', response.data)
                set_element(null)
                set_map_tata_ruang(response.data)
                set_refresh(random_character(16))
            })
            .catch((e) => {
                console.log('catch : ', e)
                error(e.message)
            }).finally(() => {
                loading(false)
                set_generate(false)
            })

        }else if(typeParams === 'kmz'){

            if(loading === true){
                return
            }
    
            loading(true);
            set_generate(true)

            API_GET_GEO_PUBLIC(`geo/get__________?action=kmztogeojson`
                + '&url=' + urlParams
            , 
            ).then((response) => {
                console_dev(`response ${request_params} kmz `, response)
                set_element(null)
                set_map_tata_ruang(response.data)
                set_refresh(random_character(16))
            })
            .catch((e) => {
                console_dev('catch', e)
                error(e.message)
            }).finally(() => {
                loading(false)
                set_generate(false)
            })

        }else{
            error('file type denied')
        }


	}

    const _read_denah_warga_map = (urlParams, typeParams) => {

        if(typeParams === 'geojson'){

            if(loading === true){
                return
            }
    
            loading(true);
            set_generate(true)
    
            API_GET_URL(urlParams)
            .then((response) => {
                console_dev('------', response.data)
                set_map_denah_warga(response.data)
                set_element(null)
                set_refresh(random_character(16))
            })
            .catch((e) => {
                console.log('catch : ', e)
                error(e.message)
            }).finally(() => {
                loading(false)
                set_generate(false)
            })

        }else if(typeParams === 'kmz'){

            if(loading === true){
                return
            }
    
            loading(true);
            set_generate(true)

            API_GET_GEO_PUBLIC(`geo/get__________?action=kmztogeojson`
                + '&url=' + urlParams
            , 
            ).then((response) => {
                console_dev(`response ${request_params} kmz `, response)
                set_map_denah_warga(response.data)
                set_element(null)
                set_refresh(random_character(16))
            })
            .catch((e) => {
                console_dev('catch', e)
                error(e.message)
            }).finally(() => {
                loading(false)
                set_generate(false)
            })

        }else{
            error('file type denied')
        }


	}
    /*--------------------------------------------------------------
    [End API]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Socket]
    ----------------------------------------------------------------*/
    const _socket = (storageUserParams) => {

        // // get
		// socket.on("get", (data) => {
		// 	console.log('get : ', data)	
		// })
		
		// // push
		// socket.emit("push", {
		// 	push : data,
		// });
		
	}
    /*--------------------------------------------------------------
    [End Socket]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Functions]
    ----------------------------------------------------------------*/
    const _coordinate_parse = (data) => {

        const NewCoordinates = new Coordinates(data);

        const NewCoordinatesParse = {
            latitude: NewCoordinates.getLatitude(),
            longitude: NewCoordinates.getLongitude()
        }
        // 3° 30' 30.7368'' N 98° 58' 31.2528'' E
        console.log('coordinate parse ---- : ', NewCoordinatesParse)
        set_search_coordinate_lat(NewCoordinates.getLatitude())
        set_search_coordinate_lng(NewCoordinates.getLongitude())
    }

    const isValidPosition = (position) => {
        var error;
        var isValid;
        try {
          isValid = true;
          new Coordinates(position);
          return isValid;
        } catch (error) {
          isValid = false;
          return isValid;
        }
    };
    
    const containerStyle = {
        height: '100vh',
        with: '100%',
        overflow: 'hidden'
    };
      
    const center = {
        lat: 3.4446069634566485,
        lng: 99.08402197118502
    };

    const LeafIcon = L.Icon.extend({
        options: {}
      });
    
    const blueIcon = new LeafIcon({
        iconUrl:
        "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-blue.png"
    });

    const greenIcon = new LeafIcon({
        iconUrl:
        "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-green.png"
    });

    const redIcon = new LeafIcon({
        iconUrl:
        "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png"
    });
    
    const _files = (event) => {

        if(!event){
            return error('Terjadi Kesalahan')
        }
        
        if(event){
            if(!event.target.files[0]){
                return error('File Dibatalkan')
            }
        }

        let foo = event.target.files[0]; 

        set_file([foo]);

	};

    const _export_png = () => {

        htmlToImage.toPng(document.getElementById('export'))
        .then(function (dataUrl) {
            var link = document.createElement('a');
            link.download = 'export.png';
            link.href = dataUrl;
            link.click();
        });

    }

    const _export_svg = () => {
        
        function filter (node) {
            return (node.tagName !== 'i');
        }
          
        htmlToImage.toSvg(document.getElementById('export'), { filter: filter })
        .then(function (dataUrl) {
            var link = document.createElement('a');
            link.download = 'export.svg';
            link.href = dataUrl;
            link.click();
        });

        
    }

    const _export_jpg = () => {
        
        htmlToImage.toJpeg(document.getElementById('export'), { quality: 0.95 })
        .then(function (dataUrl) {
            console.log('export : ', dataUrl)
            var link = document.createElement('a');
            link.download = 'export.jpeg';
            link.href = dataUrl;
            link.click();
        });

    }

    const _geojson_extract = (country, layer) => {
        // console_dev('geojson extract country-----------------', country.properties.NAMOBJ)
        // console_dev('geojson extract layer', layer)
        
        if (country.properties.NAMOBJ) {
            layer.bindPopup(country.properties.NAMOBJ);
        }
        
        if(country.properties.NAMOBJ === 'Badan Air'){
            layer.setStyle({
                weight: 2,
                opacity: 1,
                color: '#97dbf2',
                fillOpacity: 0.7,
                fillColor: '#97dbf2'
            }) 
        }else if(country.properties.NAMOBJ === 'Kawasan Ekosistem Mangrove'){
            layer.setStyle({
                weight: 2,
                opacity: 1,
                color: '#2d966e',
                fillOpacity: 0.7,
                fillColor: '#2d966e'
            }) 
        }else if(country.properties.NAMOBJ === 'Kawasan Hortikultura'){
            layer.setStyle({
                weight: 2,
                opacity: 1,
                color: '#e6ff4b',
                fillOpacity: 0.7,
                fillColor: '#e6ff4b'
            }) 
        }else if(country.properties.NAMOBJ === 'Kawasan Hutan Lindung'){
            layer.setStyle({
                weight: 2,
                opacity: 1,
                color: '#325f28',
                fillOpacity: 0.7,
                fillColor: '#325f28'
            }) 
        }else if(country.properties.NAMOBJ === 'Kawasan Hutan Produksi Terbatas'){
            layer.setStyle({
                weight: 2,
                opacity: 1,
                color: '#4b9c36',
                fillOpacity: 0.7,
                fillColor: '#4b9c36'
            }) 
        }else if(country.properties.NAMOBJ === 'Kawasan Hutan Produksi Tetap'){
            layer.setStyle({
                weight: 2,
                opacity: 1,
                color: '#69b336',
                fillOpacity: 0.7,
                fillColor: '#69b336'
            }) 
        }else if(country.properties.NAMOBJ === 'Kawasan Perikanan Budi Daya'){
            layer.setStyle({
                weight: 2,
                opacity: 1,
                color: '#80b9d2',
                fillOpacity: 0.7,
                fillColor: '#80b9d2'
            }) 
        }else if(country.properties.NAMOBJ === 'Kawasan Perkebunan'){
            layer.setStyle({
                weight: 2,
                opacity: 1,
                color: '#afaf37',
                fillOpacity: 0.7,
                fillColor: '#afaf37'
            }) 
        }else if(country.properties.NAMOBJ === 'Kawasan Permukiman Perdesaan'){
            layer.setStyle({
                weight: 2,
                opacity: 1,
                color: '#eb9b3a',
                fillOpacity: 0.7,
                fillColor: '#eb9b3a'
            }) 
        }else if(country.properties.NAMOBJ === 'Kawasan Permukiman Perkotaan'){
            layer.setStyle({
                weight: 2,
                opacity: 1,
                color: '#f59c1c',
                fillOpacity: 0.7,
                fillColor: '#f59c1c'
            }) 
        }else if(country.properties.NAMOBJ === 'Kawasan Pertahanan dan Keamanan'){
            layer.setStyle({
                weight: 2,
                opacity: 1,
                color: '#9b00fe',
                fillOpacity: 0.7,
                fillColor: '#9b00fe'
            }) 
        }else if(country.properties.NAMOBJ === 'Kawasan Peruntukan Industri'){
            layer.setStyle({
                weight: 2,
                opacity: 1,
                color: '#680000',
                fillOpacity: 0.7,
                fillColor: '#680000'
            }) 
        }else if(country.properties.NAMOBJ === 'Kawasan Tanaman Pangan'){
            layer.setStyle({
                weight: 2,
                opacity: 1,
                color: '#c9f546',
                fillOpacity: 0.7,
                fillColor: '#c9f546'
            }) 
        }else if(country.properties.NAMOBJ === 'Sempadan Pantai'){
            layer.setStyle({
                weight: 2,
                opacity: 1,
                color: '#cdffcc',
                fillOpacity: 0.7,
                fillColor: '#cdffcc'
            }) 
        }else if(country.properties.NAMOBJ === 'Sempadan Sungai'){
            layer.setStyle({
                weight: 2,
                opacity: 1,
                color: '#c3ffcc',
                fillOpacity: 0.7,
                fillColor: '#c3ffcc'
            }) 
        }
        
        else if(country.properties.NAMOBJ === 'Pertumbuhan Ekonomi'){
            layer.setStyle({
                weight: 2,
                opacity: 1,
                color: 'red',
                fillOpacity: 0.3,
                fillColor: 'red'
            }) 
        }else if(country.properties.NAMOBJ === 'Fungsi dan Daya Dukung Lingkungan Hidup'){
            layer.setStyle({
                weight: 2,
                opacity: 1,
                color: 'green',
                fillOpacity: 0.3,
                fillColor: 'green'
            }) 
        }else if(country.properties.NAMOBJ === 'Sosial dan Budaya'){
            layer.setStyle({
                weight: 2,
                opacity: 1,
                color: 'blue',
                fillOpacity: 0.3,
                fillColor: 'blue'
            }) 
        }
        
        layer.on('click', function (e) {

            // console_dev('detail --------------- : ', country.properties)

            set_element('map_detail')
            set_map_detail(country.properties)
            set_sub_element('diperbolehkan')
            
            console_dev('NAMOBJ', country.properties.NAMOBJ)
            // nama objek
            console_dev('KODKWS', country.properties.KODKWS)
            // Kode Kawasan
            console_dev('JNSRPR', country.properties.JNSRPR)
            // Jenis Rencana pola ruang
            console_dev('WADMPR', country.properties.WADMPR)
            console_dev('WADMKK', country.properties.WADMKK)
            console_dev('WADMKC', country.properties.WADMKC)
            console_dev('KKOP_1', country.properties.KKOP_1)
            // kawasan keselamatan operasional penerbangan
            console_dev('KP2B_2', country.properties.KP2B_2)
            // kawasan pertanian pangan berkelanjutan
            console_dev('KRB_03', country.properties.KRB_03)
            // kawasan rawan bencana
            console_dev('KT_KHUSUS', country.properties.KT_KHUSUS)
            // ketentuan khusus
            console_dev('LUASHA', country.properties.LUASHA)
            // Luas Hektar
            console_dev('CAGBUD', country.properties.CAGBUD)
            // cagar budaya
            console_dev('RESAIR', country.properties.RESAIR)
            // Resapan Air
            console_dev('KUPZ', country.properties.KUPZ)
            // Ketentuan Umum Dan Peraturan Zonasi
            console_dev('Diperboleh', country.properties.Diperboleh)
            // Kegiatan yang diperbolehkan
            console_dev('Bersyarat', country.properties.Bersyarat)
            // Bersyarat
            console_dev('Tidak_Dipe', country.properties.Tidak_Dipe)
            // Tidak Persyaratan
            // console_dev('OBJECTID', country.properties.OBJECTID)
            // console_dev('ORDE01', country.properties.ORDE01)
            // console_dev('ORDE02', country.properties.ORDE02)
            // console_dev('ORDE03', country.properties.ORDE03)
            // console_dev('ORDE04', country.properties.ORDE04)
            // console_dev('Shape_Area', country.properties.Shape_Area)
            // console_dev('Shape_Leng', country.properties.Shape_Leng)
            
            // console_dev('B', country.properties.B)
            // console_dev('I', country.properties.I)
            // console_dev('X', country.properties.X)
            
            // set_element('map_detail')
        })
    }

    const _map_geo_style = (feature, layer) => {
        // console_dev('map style layer', layer)
        // if(feature.properties.NAMOBJ === 'Kawasan Permukiman Perkotaan'){
        //     return {
        //         // the fillColor is adapted from a property which can be changed by the user (segment)
        //         fillColor: 'green',
        //         //stroke-width: to have a constant width on the screen need to adapt with scale 
        //         // opacity: 1,
        //         // color: 'blue',
        //     };
        // }
    }

    /*--------------------------------------------------------------
    [End Functions]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Storage User]
    ----------------------------------------------------------------*/
    const _STORAGE_USER = () => {

        if(STORAGE_USER !== undefined){

            let storage_bamboo = STORAGE_USER[0].level === 'admin' ? STORAGE_USER[0].bamboo : STORAGE_USER[0].bamboo_chain;
            
            if(storage_bamboo){
                set_bamboo_user(storage_bamboo)
                _socket(STORAGE_USER[0])
                _read_tata_ruang(1, storage_bamboo)
                _read_struktur_ruang(1, storage_bamboo)
                _read_kawasan_strategis(1, storage_bamboo)
                _read_peta_dasar(1, storage_bamboo)
                _read_peta_tematik(1, storage_bamboo)
            }

        }else{
        
        }

    }
    /*--------------------------------------------------------------
    [End Storage User]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Authentication]
    ----------------------------------------------------------------*/
    // if(STORAGE_USER !== undefined){
    //     if(STORAGE_USER[0].level === 'guest'){
    //         history.push('/')
    //     }
    // }else{
    //     history.push('/home')
    //     window.location.reload();
    // }
    /*--------------------------------------------------------------
    [End Authentication]
    ----------------------------------------------------------------*/
    
    /*--------------------------------------------------------------
    [useEffect]
    ----------------------------------------------------------------*/
    useEffect(() => {

        if(search.length > 0){
            _search()
        }else{
            _read_tata_ruang()
            _read_struktur_ruang()
            _read_kawasan_strategis()
            _read_peta_dasar()
            _read_peta_tematik()
        }

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                console.log('position lat ------------ : ', position.coords.latitude)
                console.log('position lng ------------ : ', position.coords.longitude)
                set_my_coordinate(position.coords.latitude, position.coords.longitude)
                set_coords_lat(position.coords.latitude)
                set_coords_lng(position.coords.longitude)
                set_position({
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                })
            });
        }

    }, [refresh, search])

    useEffect(() => {

        if(ref_table_height.current){
            set_table_height(ref_table_height.current.clientHeight + 5)
        }

    }, [data])

    useEffect(() => {


        
    }, [])
    /*--------------------------------------------------------------
    [End useEffect]
    ----------------------------------------------------------------*/    

    return (
        <>

            {/*  Helmet ------------------------------------------------------------------ */}
            <Helmet>

                <meta name="description" content={`${meta_title}`}/>
                <title>{`${meta_title}`}</title>

            </Helmet>
            {/*  End Helmet -------------------------------------------------------------- */}

            {/*  Tour -------------------------------------------------------------------- */}
            <Tour steps={steps} isOpen={tour} onRequestClose={() => set_tour(false)} />
            <Tour disableKeyboardNavigation={['esc']} />
            {/*  End Tour ---------------------------------------------------------------- */}

            {
                element === 'map_detail' ?
                    map_select === 'tata_ruang' ?
                        <div dangerouslySetInnerHTML={{__html: `
                            <style>
                            .leaflet-control-container { position: absolute; right: 390px; } 
                            </style>
                        `}}></div>
                    : 
                        <div dangerouslySetInnerHTML={{__html: `
                            <style>
                            .leaflet-control-container { position: absolute; right: 56px } 
                            </style>
                        `}}></div>             
                :
                    <div dangerouslySetInnerHTML={{__html: `
                        <style>
                        .leaflet-control-container { position: absolute; right: 56px } 
                        </style>
                    `}}></div>
            }

            {/*  Delete & Update ---------------------------------------------------------- */}
            {
                bamboo_delete.length > 0 ?
                    <div className="_fmc_overlay">
                        <div className="_fmc_overlay_navbar">
                            <div className="_row _center_align">
                                <div className="_column">
                                    <p className="_font_size_18px">Hapus Data</p>
                                </div>
                                <div onClick={() => {
                                    set_bamboo_delete('')
                                    set_path_client('')
                                }} className="_push_l_d _btn _cursor_pointer">
                                    Keluar
                                </div>
                            </div>
                        </div>
                        <div className="_fmc_overlay_content">
                            <div className="_container">
                                <div className="_lily_pad_h_d">
                                    <div className="_row _push_t_g _push_b_g">
                                        <div className="_column">
                                            <div className="_heading_bold _push_b_l">
                                                Cloud : <span className="_grey">Data Akan Dihapus Pada Server Kami.</span>
                                            </div>
                                            <div onClick={() => {
                                                _uploads_post(`delete_${request_params}`)
                                                // _uploads(`delete_${request_params}`)
                                            }} className="_btn _cursor_pointer">
                                                Hapus
                                            </div>
                                        </div>
                                        <div className="_fmc_overlay_bg_hide">
                                            <img style={{width: 400}} src={OverlayBg}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                : null
            }

            {
                bamboo_update.length > 0 ?
                    <div className="_fmc_overlay">
                        <div className="_fmc_overlay_navbar">
                            <div className="_row _center_align">
                                <div className="_column">
                                    <p className="_font_size_18px">Perbaharui Data</p>
                                </div>
                                <div onClick={() => {
                                    set_bamboo_update('')
                                    set_path_client('')
                                }} className="_push_l_d _btn _cursor_pointer">
                                    Keluar
                                </div>
                            </div>
                        </div>
                        <div className="_fmc_overlay_content">
                            <div className="_container">
                                <div className="_lily_pad_h_d">
                                    <div className="_row _push_t_g _push_b_g">
                                        <div className="_column">
                                            <div className="_heading_bold _push_b_l">
                                                Cloud : <span className="_grey">Semua Data Akan Disimpan Pada Server Kami.</span>
                                            </div>
                                            <div className="_relative _push_b_d">
                                                <p style={{color: '#888', fontSize: 13}}>
                                                    <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                    Test
                                                </p>
                                                <div className="_e_input">
                                                    <input 
                                                        placeholder=""
                                                        type={'text'} 
                                                        // onChange={e => set_test(e.target.value)}
                                                        // value={test}
                                                    />
                                                </div>
                                            </div>
                                            <div onClick={() => {
                                                _uploads_post(`update_${request_params}`)
                                                // if(file === null){
                                                //     _uploads(`update_text_${request_params}`)
                                                // }else{
                                                //     _uploads(`update_file_${request_params}`)
                                                // }
                                            }} className="_btn _cursor_pointer">
                                                Simpan
                                            </div>
                                        </div>
                                        <div className="_fmc_overlay_bg_hide">
                                            <img style={{width: 400}} src={OverlayBg}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                : null
            }
            {/*  End Delete & Update ------------------------------------------------------- */}

            <div style={{position: 'relative'}}>
                <div className="_simpr_home_map_nav">
                    <NavLink 
                        to='/simpr/home' 
                        className="_simpr_home_map_nav_item"
                    >
                        <div className="_simpr_home_map_nav_item_tooltip">
                            Beranda
                        </div>    
                        <ion-icon name="home-outline"></ion-icon>
                    </NavLink>
                    <div onClick={() => {
                        if(element === 'map_category'){
                            set_element(null)
                        }else{
                            set_element('map_category')
                            set_sub_element(null)
                        }

                        if(sub_element === 'map_category_tata_ruang'){
                            set_sub_element(null)
                            set_element(null)
                            set_map_tata_ruang(null)
                            set_map_denah_warga(null)
                        }
                    }} className="_simpr_home_map_nav_item" style={{backgroundColor: element === 'map_category' ? '#eee' : null}}>
                        <ion-icon name="location-outline"></ion-icon>
                        <div className="_simpr_home_map_nav_item_tooltip" style={{width: 130}}>
                            Peta Rencana
                        </div>  
                        {
                            element === 'map_category' ?
                                // _left or _right
                                <>
                                    <div className="_fmc_overlay_dropdown _left" style={{left: '130%', top: 0, borderRadius: 16}}>
                                        <div onClick={() => {
                                            set_sub_element('map_category_tata_ruang') 
                                            set_map_select('tata_ruang')
                                        }} className="_item">Tata Ruang</div>
                                        <div onClick={() => {
                                            set_sub_element('map_category_struktur_ruang')
                                            set_map_select('struktur_ruang')
                                        }} className="_item">Struktur Ruang</div>
                                        <div onClick={() => {
                                            set_sub_element('map_category_kawasan_strategis')
                                            set_map_select('kawasan_strategis')
                                        }} className="_item">Kawasan Strategis</div>
                                    </div>
                                </>
                            : null
                        }
                        {
                            sub_element === 'map_category_tata_ruang' ?
                                // _left or _right
                                <>
                                    <div className="_fmc_overlay_dropdown _left" style={{left: '130%', top: 0, borderRadius: 16}}>
                                        {
                                            data_tata_ruang && data_tata_ruang.list.length > 0 ?
                                                data_tata_ruang.list.map((item, index) => (
                                                    <div onClick={() => {
                                                        set_center_lat(item.center_lat)
                                                        set_center_lng(item.center_lng)
                                                        set_type(item.type)
                                                        _read_tata_ruang_map(API_SERVER + '/' + item.path + '/' + item.file, item.type)
                                                    }} className="_item">{decode(item.judul)}</div>
                                                ))
                                            :
                                                data_tata_ruang &&
                                                <div className="_item">Belum Ada Data</div>
                                        }
                                    </div>
                                </>
                            : null
                        }
                        {
                            sub_element === 'map_category_struktur_ruang' ?
                                // _left or _right
                                <>
                                    <div className="_fmc_overlay_dropdown _left" style={{left: '130%', top: 0, borderRadius: 16, width: 280}}>
                                        <NavLink 
                                            to='/simpr/bprb/struktur_ruang'
                                            // target="_blank" 
                                            className="_item"
                                            style={{display: 'block', fontSize: 12}}
                                        >
                                            Struktur Ruang <small style={{color: '#aaa', fontSize: 8}}>All Combine</small>
                                        </NavLink>
                                        {
                                            data_struktur_ruang && data_struktur_ruang.list.length > 0 ?
                                                data_struktur_ruang.list.map((item, index) => (
                                                    <div onClick={() => {
                                                        set_center_lat(item.center_lat)
                                                        set_center_lng(item.center_lng)
                                                        set_type(item.type)
                                                        _read_tata_ruang_map(API_SERVER + '/' + item.path + '/' + item.file, item.type)
                                                    }} className="_item" style={{fontSize: 12}}>{decode(item.judul)} <small style={{color: '#aaa', fontSize: 8}}>Part</small></div>
                                                ))
                                            :
                                                data_struktur_ruang &&
                                                <div className="_item">Belum Ada Data</div>
                                        }
                                    </div>
                                </>
                            : null
                        }
                        {
                            sub_element === 'map_category_kawasan_strategis' ?
                                // _left or _right
                                <>
                                    <div className="_fmc_overlay_dropdown _left" style={{left: '130%', top: 0, borderRadius: 16}}>
                                        {
                                            data_kawasan_strategis && data_kawasan_strategis.list.length > 0 ?
                                                data_kawasan_strategis.list.map((item, index) => (
                                                    <div onClick={() => {
                                                        set_center_lat(item.center_lat)
                                                        set_center_lng(item.center_lng)
                                                        set_type(item.type)
                                                        _read_tata_ruang_map(API_SERVER + '/' + item.path + '/' + item.file, item.type)
                                                    }} className="_item">{decode(item.judul)}</div>
                                                ))
                                            :
                                                data_kawasan_strategis &&
                                                <div className="_item">Belum Ada Data</div>
                                        }
                                    </div>
                                </>
                            : null
                        }
                    </div>
                    {
                        STORAGE_USER && STORAGE_USER[0].level === 'admin' &&
                        <div onClick={() => {
                            if(element === 'map_dasar'){
                                set_element(null)
                            }else{
                                set_element('map_dasar')
                                set_map_select('peta_dasar')
                            }
                        }} className="_simpr_home_map_nav_item" style={{backgroundColor: element === 'map_print' ? '#eee' : null}}>
                            <div className="_simpr_home_map_nav_item_tooltip" style={{width: 120}}>
                                Peta Dasar
                            </div>  
                            <ion-icon name="map-outline"></ion-icon>
                            {
                                element === 'map_dasar' ?
                                    // _left or _right
                                    <>
                                        <div className="_fmc_overlay_dropdown _left" style={{left: '130%', top: 0, borderRadius: 16}}>
                                            {
                                                data_peta_dasar && data_peta_dasar.list.length > 0 ?
                                                    data_peta_dasar.list.map((item, index) => (
                                                        <div onClick={() => {
                                                            set_center_lat(item.center_lat)
                                                            set_center_lng(item.center_lng)
                                                            set_type(item.type)
                                                            _read_tata_ruang_map(API_SERVER + '/' + item.path + '/' + item.file, item.type)
                                                        }} className="_item">{decode(item.judul)}</div>
                                                    ))
                                                :
                                                    data_peta_dasar &&
                                                    <div className="_item">Belum Ada Data</div>
                                            }
                                        </div>
                                    </>
                                : null
                            }
                        </div>
                    }

                    {
                        STORAGE_USER && STORAGE_USER[0].level === 'admin' &&
                        <div onClick={() => {
                            if(element === 'map_tematik'){
                                set_element(null)
                            }else{
                                set_element('map_tematik')
                                set_map_select('peta_tematik')
                            }
                        }} className="_simpr_home_map_nav_item" style={{backgroundColor: element === 'map_tematik' ? '#eee' : null}}>
                            <div className="_simpr_home_map_nav_item_tooltip" style={{width: 130}}>
                                Peta Tematik
                            </div>  
                            <ion-icon name="locate-outline"></ion-icon>
                            {
                                element === 'map_tematik' ?
                                    // _left or _right
                                    <>
                                        <div className="_fmc_overlay_dropdown _left" style={{left: '130%', top: 0, borderRadius: 16}}>
                                            {
                                                data_peta_tematik && data_peta_tematik.list.length > 0 ?
                                                    data_peta_tematik.list.map((item, index) => (
                                                        <div onClick={() => {
                                                            set_center_lat(item.center_lat)
                                                            set_center_lng(item.center_lng)
                                                            set_type(item.type)
                                                            _read_tata_ruang_map(API_SERVER + '/' + item.path + '/' + item.file, item.type)
                                                        }} className="_item">{decode(item.judul)}</div>
                                                    ))
                                                :
                                                    data_peta_dasar &&
                                                    <div className="_item">Belum Ada Data</div>
                                            }
                                        </div>
                                    </>
                                : null
                            }
                        </div>
                    }
                    
                    <div className="_relative">
                        <div onClick={() => {
                            if(element === 'search'){
                                set_element(null)
                            }else{
                                set_element('search')
                            }
                        }} className="_simpr_home_map_nav_item" style={{backgroundColor: element === 'search' ? '#eee' : null}}>
                            <div className="_simpr_home_map_nav_item_tooltip" style={{width: 130}}>
                                Cari Kordinat
                            </div>  
                            <ion-icon name="search-outline"></ion-icon>
                        </div>
                        {
                            element === 'search' &&
                            <div style={{position: 'absolute', top: 0, left: 60, width: 360}}>
                                <div className="_bb_search" style={{backgroundColor: '#fff', borderRadius: 8}}>
                                    <div className="_row _center_align">
                                        <div className="_column _push_r_s">
                                            <input 
                                                style={{paddingLeft: 0, paddingRight: 0, paddingBottom: 6, paddingTop: 6}}
                                                placeholder="Latitude" 
                                                onChange={e => set_search_coordinate_lat(e.target.value)}
                                                value={search_coordinate_lat}
                                            />
                                        </div>
                                        <div className="_column _push_l_s">
                                            <input 
                                                style={{paddingLeft: 0, paddingRight: 0, paddingBottom: 6, paddingTop: 6}}
                                                placeholder="Longitude" 
                                                onChange={e => set_search_coordinate_lng(e.target.value)}
                                                value={search_coordinate_lng}
                                            />
                                        </div>
                                        <div onClick={() => {
                                            set_element(null)
                                        }} style={{position: 'relative', height: 50, width: 50, marginRight: -20, cursor: 'pointer'}}>
                                            <div className="_position_middle">
                                                <ion-icon name="arrow-forward-outline" style={{fontSize: 22, color: '#888'}}></ion-icon>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{height: 1, backgroundColor: '#eee'}}/>
                                    <div className="_row _center_align">
                                        <div className="_column _push_r_s">
                                            <input 
                                                style={{paddingLeft: 0, paddingRight: 0, paddingBottom: 6, paddingTop: 6}}
                                                placeholder="DMS / DMM" 
                                                onChange={(e) => {
                                                    set_search_coordinate_dms(e.target.value)
                                                    // let isCoordinate = isValidPosition('40:7:22.8N 74:7:22.8W');
                                                    let isCoordinate = isValidPosition(e.target.value);
                                                    
                                                    if(isCoordinate === true){
                                                        _coordinate_parse(e.target.value)
                                                    }
                                                }}
                                                value={search_coordinate_dms}
                                            />
                                        </div>
                                        <div onClick={() => {
                                            set_element(null)
                                        }} style={{position: 'relative', height: 50, width: 50, marginRight: -20, cursor: 'pointer'}}>
                                            <div className="_position_middle">
                                                <ion-icon name="arrow-forward-outline" style={{fontSize: 22, color: '#888'}}></ion-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div style={{padding: 8, backgroundColor: '#fff', borderWidth: 1, borderColor: '#eee', borderStyle: 'solid', marginTop: 8, borderRadius: 8}}>
                                    <small>Kordinat hanya berfungsi pada peta dasar, peta tematik dan peta rencana. Tekan tombol panah untuk simpan kordinat</small>
                                </div>
                            </div>
                        }
                    </div>
                    {
                        STORAGE_USER && STORAGE_USER[0].level === 'admin' &&
                        <div className="_relative">
                            <div onClick={() => {
                                if(element === 'map_people'){
                                    set_element(null)
                                }else{
                                    if(map_tata_ruang){
                                        set_element('map_people')
                                    }else{
                                        error('Hanya bisa digunakan ketika sedang berapa pada menu peta geojson')
                                    }
                                }
                            }} className="_simpr_home_map_nav_item" style={{backgroundColor: element === 'map_people' ? '#eee' : null}}>
                                <div className="_simpr_home_map_nav_item_tooltip">
                                    Denah
                                </div>  
                                <ion-icon name="layers-outline"></ion-icon>
                            </div>
                            {
                                element === 'map_people' ?
                                    // _left or _right
                                    <>
                                        <div className="_fmc_overlay_dropdown _left" style={{left: '130%', top: 0, borderRadius: 16}}>
                                            <div className="_bb_search" style={{backgroundColor: 'transparent'}}>
                                                <div className="_row _center_align">
                                                    <ion-icon name="search-outline" style={{fontSize: 20}}></ion-icon>
                                                    <div className="_column">
                                                        <input 
                                                            placeholder="Cari" 
                                                            onChange={e => set_search(e.target.value)}
                                                            value={search}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            {
                                                data_denah_warga && data_denah_warga.list.length > 0 ?
                                                    data_denah_warga.list.map((item, index) => (
                                                        <div onClick={() => {
                                                            // set_center_lat(item.center_lat)
                                                            // set_center_lng(item.center_lng)
                                                            // set_type(item.type)
                                                            if(item.file_array === null){
                                                                console.log('item: ', getExtention(item.file)[0])
                                                                _read_denah_warga_map(API_SERVER + '/' + item.path + '/' + item.file, getExtention(item.file)[0])
                                                            }else{
                                                                error('hanya diizinkan 1 file data, diantara kmz atau geojson')
                                                            }
                                                        }} className="_item">{decode(item.judul)}</div>
                                                    ))
                                                :
                                                    data_denah_warga &&
                                                    <div className="_item">Belum Ada Data</div>
                                            }
                                        </div>
                                    </>
                                : null
                            }
                        </div>
                    }
                    <div onClick={() => {
                        if(sub_element === 'map_print'){
                            set_sub_element(null)
                        }else{
                            if(map_tata_ruang){
                                set_sub_element('map_print')
                            }else{
                                error('Hanya bisa digunakan ketika sedang berapa pada menu peta geojson')
                            }
                        }
                    }} className="_simpr_home_map_nav_item" style={{backgroundColor: sub_element === 'map_print' ? '#eee' : null}}>
                        <div className="_simpr_home_map_nav_item_tooltip">
                            Export
                        </div>  
                        <ion-icon name="print-outline"></ion-icon>
                        {
                            sub_element === 'map_print' ?
                                // _left or _right
                                <>
                                    <div className="_fmc_overlay_dropdown _left" style={{left: '130%', top: 0, borderRadius: 16, padding: 16}}>
                                        <div>
                                            <div onClick={() => {_export_png()}} className="_btn _cursor_pointer _push_r_s" style={{paddingTop: 4, paddingBottom: 4, paddingLeft: 14, paddingRight: 14}}>
                                                PNG
                                            </div>
                                            <div onClick={() => {_export_jpg()}} className="_btn _cursor_pointer _push_r_s" style={{paddingTop: 4, paddingBottom: 4, paddingLeft: 14, paddingRight: 14}}>
                                                JPG
                                            </div>
                                            <div onClick={() => {_export_svg()}} className="_btn _cursor_pointer _push_r_s" style={{paddingTop: 4, paddingBottom: 4, paddingLeft: 14, paddingRight: 14}}>
                                                SVG
                                            </div>
                                        </div>
                                        <br/>
                                        <p>Tekan <span className="_badge_green">ctrl</span> + p untuk memunculkan fitur print browser</p>
                                    </div>
                                </>
                            : null
                        }
                    </div>
                    {/* <NavLink 
                        to='/simpr/bprb/menu' 
                        className="_simpr_home_map_nav_item"
                    >
                        <div className="_simpr_home_map_nav_item_tooltip">
                            Menu
                        </div>    
                        <ion-icon name="apps-outline"></ion-icon>
                    </NavLink>
                    <NavLink 
                        to='/simpr/bprb/login' 
                        className="_simpr_home_map_nav_item"
                    >
                        <div className="_simpr_home_map_nav_item_tooltip">
                            Login/Register
                        </div>    
                        <ion-icon name="finger-print-outline"></ion-icon>
                    </NavLink> */}

                </div>
                
                {
                    data_tata_ruang &&
                    coords_lat > 0 && coords_lng > 0 &&
                    <div style={{position: 'absolute', bottom: 20, left: 10, zIndex: 100, backgroundColor: '#fff', borderWidth: 1, borderColor: '#eee', borderStyle: 'solid', padding: 8, borderRadius: 4}}>
                        <div className="_row _center_align">
                            <div style={{width: 120}}>
                                <p style={{fontSize: 11, marginBottom: -1}}>Decimal degrees</p>
                            </div>
                            <div className="_column">
                                <p style={{fontSize: 11, marginBottom: -1}}> : {position.lat}, {position.lng}</p>
                            </div>
                        </div>
                        <div className="_row _center_align">
                            <div style={{width: 120}}>
                                <p style={{fontSize: 11, marginBottom: -1}}>UTM-WGS84</p>
                            </div>
                            <div className="_column">
                                <p style={{fontSize: 11, marginBottom: -1}}> : {utm.fromLatLon(coords_lat, coords_lng).easting}, {utm.fromLatLon(coords_lat, coords_lng).northing}, {utm.fromLatLon(coords_lat, coords_lng).zoneNum}, {utm.fromLatLon(coords_lat, coords_lng).zoneLetter}</p>
                            </div>
                        </div>
                        {/* {
                            console_dev('----------------', utm.fromLatLon(coords_lat, coords_lng))
                        } */}
                    </div>
                }

                <div id="export" style={{position: 'relative', zIndex: 0, backgroundColor: '#fff'}}>
                    <div style={{position: 'relative', zIndex: 1, backgroundColor: '#fff'}}>
                        <div style={{position: 'relative'}}>
                            {
                                map_tata_ruang ?
                                    <MapContainer key={refresh} center={[center_lat, center_lng]} zoom={12} scrollWheelZoom={true} style={{height: '100vh'}}>
                                        <TileLayer
                                            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                        />
                                        {
                                            map_denah_warga &&
                                            <GeoJSON 
                                                key={refresh} 
                                                data={map_denah_warga} 
                                            />
                                        }
                                        <GeoJSON 
                                            key={refresh} 
                                            ref={mapRef}
                                            data={map_tata_ruang} 
                                            onEachFeature={(country, layer) => {
                                                _geojson_extract(country, layer)
                                            }}
                                            style={_map_geo_style} 
                                        />
                                        {
                                            position &&
                                            <Marker key={random_character(16)} icon={greenIcon} position={[parseFloat(position.lat), parseFloat(position.lng)]}>
                                                <Popup>
                                                    Your Position (Jika tidak akurat pastikan anda menggunakan fitur GPS)
                                                </Popup>
                                            </Marker>
                                        }
                                        {
                                            // console_dev('search coordinate -----------', search_coordinate_lat, search_coordinate_lng),
                                            // console_dev('search coordinate utm -----------', utm.fromLatLon(search_coordinate_lat, search_coordinate_lng)),
                                            search_coordinate_lat > 0 && search_coordinate_lng > 0 &&
                                            // 3.5085398, 98.9753452
                                            <Marker key={random_character(16)} icon={redIcon} position={[parseFloat(search_coordinate_lat), parseFloat(search_coordinate_lng)]}>
                                                <Popup>
                                                    Lokasi Pencarian
                                                </Popup>
                                            </Marker>
                                        }
                                    </MapContainer>
                                :
                                    <iframe src="https://tataruang.serdangbedagaikab.go.id/html/simpr/struktur_ruang.html" style={{width: '100%', height: '100vh'}} ></iframe>
                            }
                        </div>
                    </div>
                        {
                            map_select === 'tata_ruang' ?
                                element === 'map_detail' ?
                                    <div className="_simpr_sidebar_map_detail">
                                        <div className="_simpr_sidebar_map_detail_content">
                                            <h2 style={{fontSize: 30}}>Map <span style={{color: 'seagreen'}}>Detail</span></h2>
                                            <p style={{fontSize: 16, marginTop: 8}}>Seluruh detail map tata ruang pada kordinat terpilih.</p>
                                            {/* <div className="_push_t_d">
                                                <p className="_push_b_s"><ion-icon name="location-outline" style={{fontSize: 16, marginRight: 4, marginBottom: -2}}></ion-icon> Kordinat</p>
                                                <p className="_push_b_s"><ion-icon name="trail-sign-outline" style={{fontSize: 16, marginRight: 4, marginBottom: -3}}></ion-icon> Alamat</p>
                                            </div> */}
                                            <div className="_push_t_d">
                                                {/* <div className="_relative">
                                                    <div onClick={() => {
                                                        if(sub_element === 'dropdown_kegiatan'){
                                                            set_sub_element(null)
                                                        }else{
                                                            set_sub_element('dropdown_kegiatan')
                                                        }
                                                    }} className="_btn _cursor_pointer" style={{display: 'block'}}>
                                                        <div className="_row _center_align">
                                                            <div className="_column">
                                                                Pilih Jenis Sub Kegiatan
                                                            </div>
                                                            <div className="_push_l_m _push_t_t">
                                                                {
                                                                    sub_element === 'dropdown_kegiatan' ?
                                                                        <ion-icon name="chevron-up-outline"></ion-icon>
                                                                    :
                                                                        <ion-icon name="chevron-down-outline"></ion-icon>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {
                                                        sub_element === 'dropdown_kegiatan' ?
                                                            // _left or _right
                                                            <>
                                                                <div className="_fmc_overlay_dropdown _left" style={{width: '100%'}}>
                                                                    <div onClick={() => {}} className="_item">1. oke</div>
                                                                    <div onClick={() => {}} className="_item">1. oke</div>
                                                                    <div onClick={() => {}} className="_item">1. oke</div>
                                                                    <div onClick={() => {}} className="_item">1. oke</div>
                                                                </div>
                                                            </>
                                                        : null
                                                    }
                                                </div>
                                                */}
                                                {
                                                    map_detail &&
                                                    <>
                                                        {/* <div className="_push_t_m _cl_smooth_2">{map_detail.KUPZ}</div> */}
                                                        {/* <div className="_push_t_m _cl_smooth_2">{map_detail.B}</div> */}
                                                        {/* <p style={{fontSize: 14, marginTop: 16, textTransform: 'uppercase'}}><ion-icon name="ellipse-outline" style={{fontSize: 18, marginBottom: -3, marginRight: 4}}></ion-icon> Kawasan</p>
                                                        <div className="_push_t_m _cl_smooth_2">{map_detail.NAMOBJ}</div>
                                                        <p style={{fontSize: 14, marginTop: 16, textTransform: 'uppercase'}}><ion-icon name="ellipse-outline" style={{fontSize: 18, marginBottom: -3, marginRight: 4}}></ion-icon> LUAS</p>
                                                        <div className="_push_t_m _cl_smooth_2">{map_detail.LUASHA}</div>
                                                        <p style={{fontSize: 14, marginTop: 16, textTransform: 'uppercase'}}><ion-icon name="ellipse-outline" style={{fontSize: 18, marginBottom: -3, marginRight: 4}}></ion-icon> Bersyarat</p>
                                                        <div className="_push_t_m _cl_smooth_2">{map_detail.Bersyarat}</div>
                                                        <p style={{fontSize: 14, marginTop: 16, textTransform: 'uppercase'}}><ion-icon name="ellipse-outline" style={{fontSize: 18, marginBottom: -3, marginRight: 4}}></ion-icon> Diperbolehkan</p>
                                                        <div className="_push_t_m _cl_smooth_2">{map_detail.Diperboleh}</div>
                                                        <p style={{fontSize: 14, marginTop: 16, textTransform: 'uppercase'}}><ion-icon name="ellipse-outline" style={{fontSize: 18, marginBottom: -3, marginRight: 4}}></ion-icon> Tidak Diperbolehkan</p>
                                                        <div className="_push_t_m _cl_smooth_2">{map_detail.Tidak_Dipe}</div> */}
                                                        {/* <p style={{fontSize: 14, marginTop: 16, textTransform: 'uppercase'}}><ion-icon name="ellipse-outline" style={{fontSize: 18, marginBottom: -3, marginRight: 4}}></ion-icon> undefined</p> */}
                                                        {/* <div className="_push_t_m _cl_smooth_2">{map_detail.I}</div> */}
                                                        {/* <p style={{fontSize: 14, marginTop: 16, textTransform: 'uppercase'}}><ion-icon name="ellipse-outline" style={{fontSize: 18, marginBottom: -3, marginRight: 4}}></ion-icon> CAGAR BUDAYA</p>
                                                        <div className="_push_t_m _cl_smooth_2">{map_detail.CAGBUD}</div>
                                                        <p style={{fontSize: 14, marginTop: 16, textTransform: 'uppercase'}}><ion-icon name="ellipse-outline" style={{fontSize: 18, marginBottom: -3, marginRight: 4}}></ion-icon> Jenis Rencana Pola Ruang</p>
                                                        <div className="_push_t_m _cl_smooth_2">{map_detail.JNSRPR}</div>
                                                        <p style={{fontSize: 14, marginTop: 16, textTransform: 'uppercase'}}><ion-icon name="ellipse-outline" style={{fontSize: 18, marginBottom: -3, marginRight: 4}}></ion-icon> KAWASAN KESELAMATAN OPERASI PENERBANGAN</p>
                                                        <div className="_push_t_m _cl_smooth_2">{map_detail.KKOP_1}</div>
                                                        <p style={{fontSize: 14, marginTop: 16, textTransform: 'uppercase'}}><ion-icon name="ellipse-outline" style={{fontSize: 18, marginBottom: -3, marginRight: 4}}></ion-icon> KODE KAWASAN</p>
                                                        <div className="_push_t_m _cl_smooth_2">{map_detail.KODKWS}</div>
                                                        <p style={{fontSize: 14, marginTop: 16, textTransform: 'uppercase'}}><ion-icon name="ellipse-outline" style={{fontSize: 18, marginBottom: -3, marginRight: 4}}></ion-icon> KAWASAN PERTANIAN PANGAN BERKELANJUTAN</p>
                                                        <div className="_push_t_m _cl_smooth_2">{map_detail.KP2B_2}</div>
                                                        <p style={{fontSize: 14, marginTop: 16, textTransform: 'uppercase'}}><ion-icon name="ellipse-outline" style={{fontSize: 18, marginBottom: -3, marginRight: 4}}></ion-icon> KAWASAN RAWAN BENCANA</p>
                                                        <div className="_push_t_m _cl_smooth_2">{map_detail.KRB_03}</div>
                                                        <p style={{fontSize: 14, marginTop: 16, textTransform: 'uppercase'}}><ion-icon name="ellipse-outline" style={{fontSize: 18, marginBottom: -3, marginRight: 4}}></ion-icon> KETENTUAN KHUSUS</p>
                                                        <div className="_push_t_m _cl_smooth_2">{map_detail.KT_KHUSUS}</div> */}
                                                        {/* <div className="_push_t_m _cl_smooth_2">{map_detail.KUPZ}</div> */}
                                                        {/* <p style={{fontSize: 14, marginTop: 16, textTransform: 'uppercase'}}><ion-icon name="ellipse-outline" style={{fontSize: 18, marginBottom: -3, marginRight: 4}}></ion-icon> NAMA OBJEK</p>
                                                        <div className="_push_t_m _cl_smooth_2">{map_detail.OBJECTID}</div>
                                                        <p style={{fontSize: 14, marginTop: 16, textTransform: 'uppercase'}}><ion-icon name="ellipse-outline" style={{fontSize: 18, marginBottom: -3, marginRight: 4}}></ion-icon> ORDE1</p>
                                                        <div className="_push_t_m _cl_smooth_2">{map_detail.ORDE01}</div>
                                                        <p style={{fontSize: 14, marginTop: 16, textTransform: 'uppercase'}}><ion-icon name="ellipse-outline" style={{fontSize: 18, marginBottom: -3, marginRight: 4}}></ion-icon> ORDE2</p>
                                                        <div className="_push_t_m _cl_smooth_2">{map_detail.ORDE02}</div>
                                                        <p style={{fontSize: 14, marginTop: 16, textTransform: 'uppercase'}}><ion-icon name="ellipse-outline" style={{fontSize: 18, marginBottom: -3, marginRight: 4}}></ion-icon> ORDE3</p>
                                                        <div className="_push_t_m _cl_smooth_2">{map_detail.ORDE03}</div>
                                                        <p style={{fontSize: 14, marginTop: 16, textTransform: 'uppercase'}}><ion-icon name="ellipse-outline" style={{fontSize: 18, marginBottom: -3, marginRight: 4}}></ion-icon> ORDE4</p>
                                                        <div className="_push_t_m _cl_smooth_2">{map_detail.ORDE04}</div>
                                                        <p style={{fontSize: 14, marginTop: 16, textTransform: 'uppercase'}}><ion-icon name="ellipse-outline" style={{fontSize: 18, marginBottom: -3, marginRight: 4}}></ion-icon> RESAPAN AIR</p>
                                                        <div className="_push_t_m _cl_smooth_2">{map_detail.RESAIR}</div>
                                                        <p style={{fontSize: 14, marginTop: 16, textTransform: 'uppercase'}}><ion-icon name="ellipse-outline" style={{fontSize: 18, marginBottom: -3, marginRight: 4}}></ion-icon> Shape Area</p>
                                                        <div className="_push_t_m _cl_smooth_2">{map_detail.Shape_Area}</div>
                                                        <p style={{fontSize: 14, marginTop: 16, textTransform: 'uppercase'}}><ion-icon name="ellipse-outline" style={{fontSize: 18, marginBottom: -3, marginRight: 4}}></ion-icon> Shape Leng</p>
                                                        <div className="_push_t_m _cl_smooth_2">{map_detail.Shape_Leng}</div>
                                                        <p style={{fontSize: 14, marginTop: 16, textTransform: 'uppercase'}}><ion-icon name="ellipse-outline" style={{fontSize: 18, marginBottom: -3, marginRight: 4}}></ion-icon> WILAYAH ADMINISTRASI KECAMATAN</p>
                                                        <div className="_push_t_m _cl_smooth_2">{map_detail.WADMKC}</div>
                                                        <p style={{fontSize: 14, marginTop: 16, textTransform: 'uppercase'}}><ion-icon name="ellipse-outline" style={{fontSize: 18, marginBottom: -3, marginRight: 4}}></ion-icon> WILAYAH ADMINISTRASI KABUPATEN</p>
                                                        <div className="_push_t_m _cl_smooth_2">{map_detail.WADMKK}</div>
                                                        <p style={{fontSize: 14, marginTop: 16, textTransform: 'uppercase'}}><ion-icon name="ellipse-outline" style={{fontSize: 18, marginBottom: -3, marginRight: 4}}></ion-icon> WILAYAH ADMINISTRASI PROVINSI</p>
                                                        <div className="_push_t_m _cl_smooth_2">{map_detail.WADMPR}</div> */}


                                                        <p style={{fontSize: 12, marginTop: 16, textTransform: 'uppercase'}}><ion-icon name="ellipse-outline" style={{fontSize: 14, marginBottom: -2, marginRight: 4}}></ion-icon> Nama Objek</p>
                                                        <div className="_push_t_m _cl_smooth_2">{map_detail.NAMOBJ}</div>
                                                        
                                                        <p style={{fontSize: 12, marginTop: 16, textTransform: 'uppercase'}}><ion-icon name="ellipse-outline" style={{fontSize: 14, marginBottom: -2, marginRight: 4}}></ion-icon> Kode Kawasan</p>
                                                        <div className="_push_t_m _cl_smooth_2">{map_detail.KODKWS}</div>
                                                        
                                                        <p style={{fontSize: 12, marginTop: 16, textTransform: 'uppercase'}}><ion-icon name="ellipse-outline" style={{fontSize: 14, marginBottom: -2, marginRight: 4}}></ion-icon> Jenis Rencana pola ruang</p>
                                                        <div className="_push_t_m _cl_smooth_2">{map_detail.JNSRPR}</div>

                                                        <p style={{fontSize: 12, marginTop: 16, textTransform: 'uppercase'}}><ion-icon name="ellipse-outline" style={{fontSize: 14, marginBottom: -2, marginRight: 4}}></ion-icon> WILAYAH ADMINISTRASI PROVINSI</p>
                                                        <div className="_push_t_m _cl_smooth_2">{map_detail.WADMPR}</div>

                                                        <p style={{fontSize: 12, marginTop: 16, textTransform: 'uppercase'}}><ion-icon name="ellipse-outline" style={{fontSize: 14, marginBottom: -2, marginRight: 4}}></ion-icon> WILAYAH ADMINISTRASI KABUPATEN</p>
                                                        <div className="_push_t_m _cl_smooth_2">{map_detail.WADMKK}</div>

                                                        <p style={{fontSize: 12, marginTop: 16, textTransform: 'uppercase'}}><ion-icon name="ellipse-outline" style={{fontSize: 14, marginBottom: -2, marginRight: 4}}></ion-icon> WILAYAH ADMINISTRASI KECAMATAN</p>
                                                        <div className="_push_t_m _cl_smooth_2">{map_detail.WADMKC}</div>

                                                        <p style={{fontSize: 12, marginTop: 16, textTransform: 'uppercase'}}><ion-icon name="ellipse-outline" style={{fontSize: 14, marginBottom: -2, marginRight: 4}}></ion-icon> Kawasan Keselamatan Operasional Penerbangan</p>
                                                        <div className="_push_t_m _cl_smooth_2">{map_detail.KKOP_1}</div>

                                                        <p style={{fontSize: 12, marginTop: 16, textTransform: 'uppercase'}}><ion-icon name="ellipse-outline" style={{fontSize: 14, marginBottom: -2, marginRight: 4}}></ion-icon> Kawasan Pertanian Pangan Berkelanjutan</p>
                                                        <div className="_push_t_m _cl_smooth_2">{map_detail.KP2B_2}</div>

                                                        <p style={{fontSize: 12, marginTop: 16, textTransform: 'uppercase'}}><ion-icon name="ellipse-outline" style={{fontSize: 14, marginBottom: -2, marginRight: 4}}></ion-icon> kawasan rawan bencana</p>
                                                        <div className="_push_t_m _cl_smooth_2">{map_detail.KRB_03}</div>

                                                        <p style={{fontSize: 12, marginTop: 16, textTransform: 'uppercase'}}><ion-icon name="ellipse-outline" style={{fontSize: 14, marginBottom: -2, marginRight: 4}}></ion-icon> Ketentuan Khusus</p>
                                                        <div className="_push_t_m _cl_smooth_2">{map_detail.KT_KHUSUS}</div>
                                                        
                                                        <p style={{fontSize: 12, marginTop: 16, textTransform: 'uppercase'}}><ion-icon name="ellipse-outline" style={{fontSize: 14, marginBottom: -2, marginRight: 4}}></ion-icon> Luas Hektar</p>
                                                        <div className="_push_t_m _cl_smooth_2">{map_detail.LUASHA}</div>
                                                        
                                                        <p style={{fontSize: 12, marginTop: 16, textTransform: 'uppercase'}}><ion-icon name="ellipse-outline" style={{fontSize: 14, marginBottom: -2, marginRight: 4}}></ion-icon> Cagar Budaya</p>
                                                        <div className="_push_t_m _cl_smooth_2">{map_detail.CAGBUD}</div>

                                                        <p style={{fontSize: 12, marginTop: 16, textTransform: 'uppercase'}}><ion-icon name="ellipse-outline" style={{fontSize: 14, marginBottom: -2, marginRight: 4}}></ion-icon> Resapan Air</p>
                                                        <div className="_push_t_m _cl_smooth_2">{map_detail.RESAIR}</div>

                                                        <p style={{fontSize: 12, marginTop: 16, textTransform: 'uppercase'}}><ion-icon name="ellipse-outline" style={{fontSize: 14, marginBottom: -2, marginRight: 4}}></ion-icon> Ketentuan Umum Dan Peraturan Zonasi</p>
                                                        <div className="_push_t_m _cl_smooth_2">{map_detail.KUPZ}</div>
                                                        
                                                        <div className="_row _center_align _push_t_m _push_b_d">
                                                            <div onClick={() => {
                                                                if(sub_element === 'diperbolehkan'){
                                                                    set_sub_element(null)
                                                                }else{
                                                                    set_sub_element('diperbolehkan')
                                                                }
                                                            }} style={{backgroundColor: sub_element === 'diperbolehkan' ? 'seagreen' : null, color: sub_element === 'diperbolehkan' ? '#fff' : null, cursor: 'pointer', borderWidth: 1, borderColor: '#ddd', borderStyle: 'solid', textAlign: 'center', padding: 8, paddingTop: 4, paddingBottom: 4}}>
                                                                <p style={{fontSize: 10, marginBottom: -1}}>Diperbolehkan</p>
                                                            </div>
                                                            <div onClick={() => {
                                                                if(sub_element === 'bersyarat'){
                                                                    set_sub_element(null)
                                                                }else{
                                                                    set_sub_element('bersyarat')
                                                                }
                                                            }} style={{backgroundColor: sub_element === 'bersyarat' ? 'seagreen' : null, color: sub_element === 'bersyarat' ? '#fff' : null, cursor: 'pointer', borderWidth: 1, borderColor: '#ddd', borderStyle: 'solid', textAlign: 'center', padding: 8, paddingTop: 4, paddingBottom: 4}}>
                                                                <p style={{fontSize: 10, marginBottom: -1}}>Bersyarat</p>
                                                            </div>
                                                            <div className="_column" onClick={() => {
                                                                if(sub_element === 'tidakdiperbolehkan'){
                                                                    set_sub_element(null)
                                                                }else{
                                                                    set_sub_element('tidakdiperbolehkan')
                                                                }
                                                            }} style={{backgroundColor: sub_element === 'tidakdiperbolehkan' ? 'seagreen' : null, color: sub_element === 'tidakdiperbolehkan' ? '#fff' : null, cursor: 'pointer', borderWidth: 1, borderColor: '#ddd', borderStyle: 'solid', textAlign: 'center', padding: 8, paddingTop: 4, paddingBottom: 4}}>
                                                                <p style={{fontSize: 10, marginBottom: -1}}>Tidak Diperbolehkan</p>
                                                            </div>
                                                        </div>
                                                        {
                                                            sub_element === 'diperbolehkan' ?
                                                                <>
                                                                    {/* <p style={{fontSize: 12, marginTop: 16, textTransform: 'uppercase'}}><ion-icon name="ellipse-outline" style={{fontSize: 14, marginBottom: -2, marginRight: 4}}></ion-icon> Diperboleh</p> */}
                                                                    {/* <div className="_push_t_m _cl_smooth_2">{map_detail.Diperboleh}</div> */}
                                                                    {
                                                                        map_detail.NAMOBJ === 'Badan Air' ?
                                                                            <div style={{fontSize: 13}}></div>
                                                                        : map_detail.NAMOBJ === 'Kawasan Ekosistem Mangrove' ?
                                                                            <div style={{fontSize: 13}}>
                                                                                pemanfaatan ruang untuk kegiatan penelitian dan pengembangan, pendidikan, kegiatan penunjang budidaya (karya wisata, widya wisata, peragaan dokumentasi potensi kawasan), kegiatan terkait pencegahan bencana alam;
                                                                            </div>
                                                                        : map_detail.NAMOBJ === 'Kawasan Hortikultura' ?
                                                                            <div style={{fontSize: 13}}>
                                                                                1. kegiatan pertanian hortikultura, jaringan dan bangunan irigasi;
                                                                                <br/><br/>
                                                                                2. permukiman perdesaan berkepadatan rendah;
                                                                                <br/><br/>
                                                                                3. campuran dominan dengan peruntukan tanaman pangan, perkebunan, peternakan, budidaya perikanan;
                                                                                <br/><br/>
                                                                                4. pariwisata pasif;
                                                                                <br/><br/>
                                                                                5. bangunan dan kegiatan adat, budaya dan keagamaan;
                                                                                <br/><br/>
                                                                                6. pengalihan fungsi lahan hortikultura menjadi lahan pertanian pangan berkelanjutan yang dilakukan secara bertahap.
                                                                            </div>
                                                                        : map_detail.NAMOBJ === 'Kawasan Hutan Lindung' ?
                                                                            <div style={{fontSize: 13}}>
                                                                                a. diperbolehkan meliputi kegiatan perhutanan sosial untuk pemanfaatan jasa lingkungan berupa wisata alam, wisata buru, air dan energi air, perikanan budidaya non intensif, karbon hutan, energi angin, energi panas matahari serta keanekaragaman dan keindahan jenis tumbuhan dan satwa liar, budidaya tradisional, kegiatan pemungutan hasil hutan bukan kayu dengan tidak merusak lingkungan dan mengurangi fungsi utamanya;
                                                                                <br/><br/>
                                                                                b. diperbolehkan penggunaan kawasan hutan lindung untuk kepentingan pembangunan di luar kegiatan kehutanan yang mempunyai tujuan strategis yang tak dapat dielakkan, meliputi;
                                                                                <br/><br/>
                                                                                1. kegiatan religi antara lain tempat ibadah, tempat pemakaman dan wisata rohani;
                                                                                <br/><br/>
                                                                                2. sarana transportasi yang tidak dikategorikan sebagai sarana transportasi umum untuk keperluan pengangkutan hasil produksi;
                                                                                <br/><br/>
                                                                                3. jalur evakuasi bencana alam, penampungan korban bencana alam dan lahan usahanya yang bersifat sementara;
                                                                                <br/><br/>
                                                                                4. pertanian tertentu dalam rangka ketahanan pangan; dan
                                                                                pertanian tertentu dalam rangka ketahanan energi.
                                                                            </div>
                                                                        : map_detail.NAMOBJ === 'Kawasan Hutan Produksi Terbatas' ?
                                                                            <div style={{fontSize: 13}}>
                                                                                1. pemanfaatan hasil hutan dengan perlakuan cara tebang pilih; 
                                                                                <br/><br/>
                                                                                2. produksi kayu dengan intensitas rendah;
                                                                                <br/><br/>
                                                                                3. pendirian bangunan penunjang kegiatan pengamanan kawasan;
                                                                                <br/><br/>
                                                                                4. dan pengembangan fungsi hutan produksi terbatas menjadi hutan berfungsi lindung.
                                                                                <br/><br/>
                                                                            </div>
                                                                        : map_detail.NAMOBJ === 'Kawasan Hutan Produksi Tetap' ?
                                                                            <div style={{fontSize: 13}}>
                                                                                1. pemanfaatan hasil hutan dengan perlakuan cara tebang pilih maupun dengan cara tebang habis; 
                                                                                <br/><br/>
                                                                                2. dan pendirian bangunan penunjang kegiatan pengamanan kawasan;
                                                                            </div>
                                                                        : map_detail.NAMOBJ === 'Kawasan Perikanan Budi Daya' ?
                                                                            <div style={{fontSize: 13}}>
                                                                                1. budidaya ikan di perairan umum (danau, sungai, waduk dan rawa);
                                                                                <br/><br/>
                                                                                2. budidaya ikan perairan laut;
                                                                                <br/><br/>
                                                                                3. budidaya ikan di kolam;
                                                                                <br/><br/>
                                                                                4. budidaya ikan di tambak;
                                                                                <br/><br/>
                                                                                5. budidaya ikan di saluran irigasi;
                                                                                <br/><br/>
                                                                                6. budidaya ikan bersama padi di sawah;
                                                                                <br/><br/>
                                                                                7. budidaya ikan di genangan air lainnya;
                                                                                <br/><br/>
                                                                                8. budidaya udang di tambak.
                                                                            </div>
                                                                        : map_detail.NAMOBJ === 'Kawasan Perkebunan' ?
                                                                            <div style={{fontSize: 13}}>
                                                                                1. kegiatan perkebunan skala kecil, menengah dan besar (milik perorangan, pemerintah atau perusahaan) atau berkelompok (perkebunan milik kelompok masyarakat yang terkoordinasi);
                                                                                <br/><br/>
                                                                                2. aktivitas pembibitan;
                                                                                <br/><br/>
                                                                                3. permukiman perdesaan berkepadatan rendah;
                                                                                <br/><br/>
                                                                                4. campuran dominan perkebunan dengan tanaman pangan, hortikultura, peternakan; dan
                                                                                <br/><br/>
                                                                                5. hutan rakyat secara terbatas.
                                                                            </div>
                                                                        : map_detail.NAMOBJ === 'Kawasan Permukiman Perdesaan' ?
                                                                            <div style={{fontSize: 13}}>
                                                                                a. hunian; 
                                                                                <br/><br/>
                                                                                b. pemerintahan;
                                                                                <br/><br/>
                                                                                c. fasilitas rekreasi dan olah raga;
                                                                                <br/><br/>
                                                                                d. kesehatan;
                                                                                <br/><br/>
                                                                                e. perdagangan dan jasa skala lingkungan; 
                                                                                <br/><br/>
                                                                                f. pendidikan;
                                                                                <br/><br/>
                                                                                g. fasilitas umum penunjang permukiman lainnya. 
                                                                            </div>
                                                                        : map_detail.NAMOBJ === 'Kawasan Permukiman Perkotaan' ?
                                                                            <div style={{fontSize: 13}}>
                                                                                a. hunian; 
                                                                                <br/><br/>
                                                                                b. rekreasi dan olah raga;
                                                                                <br/><br/>
                                                                                c. perdagangan dan jasa; 
                                                                                <br/><br/>
                                                                                d. pemerintahan;
                                                                                <br/><br/>
                                                                                e. pendidikan; 
                                                                                <br/><br/>
                                                                                f. peribadatan dan ruang terbuka hijau
                                                                            </div>
                                                                        : map_detail.NAMOBJ === 'Kawasan Pertahanan dan Keamanan' ?
                                                                            <div style={{fontSize: 13}}>
                                                                                kegiatan berupa pembangunan yang berkaitan dengan kebutuhan pertahanan dan keamanan;
                                                                            </div>
                                                                        : map_detail.NAMOBJ === 'Kawasan Peruntukan Industri' ?
                                                                            <div style={{fontSize: 13}}>
                                                                                1. kegiatan industri sesuai jenis industri yang telah mendapatkan perizinan;
                                                                                <br/><br/>
                                                                                2. kegiatan penyimpanan;
                                                                                <br/><br/>
                                                                                3. kegiatan perakitan;
                                                                                <br/><br/>
                                                                                4. kegiatan penyortiran; 
                                                                                <br/><br/>
                                                                                5. kegiatan pengepakan; 
                                                                                <br/><br/>
                                                                                6. kegiatan pendistribusian; 
                                                                                <br/><br/>
                                                                                7. kegiatan perbaikan, dan perekondisian permesinan;
                                                                                <br/><br/>
                                                                                8. fasilitas pendukung operasional lainnya;
                                                                            </div>
                                                                        : map_detail.NAMOBJ === 'Kawasan Tanaman Pangan' ?
                                                                            <div style={{fontSize: 13}}>
                                                                                1. kegiatan pertanian tanaman pangan;
                                                                                <br/><br/>
                                                                                2. jaringan dan bangunan irigasi, dan jalan produksi;
                                                                            </div>
                                                                        : map_detail.NAMOBJ === 'Sempadan Pantai' ?
                                                                            <div style={{fontSize: 13}}>
                                                                                1. rekreasi pantai;
                                                                                <br/> <br/>
                                                                                2. ruang terbuka hijau;
                                                                                <br/><br/>
                                                                                3. taman pantai;
                                                                                <br/><br/>
                                                                                4. mitigasi bencana pesisir;
                                                                                <br/><br/>
                                                                                5. pertanian;
                                                                                <br/> <br/>
                                                                                6. kegiatan penelitian;
                                                                                <br/> <br/>
                                                                                7. ruang parkir terbuka;
                                                                                <br/> <br/>
                                                                                8. ruang/jalur pejalan kaki;
                                                                                <br/> <br/>
                                                                                9. ruang terbuka publik;
                                                                                <br/> <br/>
                                                                                10. perlindungan budidaya maritim;
                                                                                <br/> <br/>
                                                                                11. kegiatan upacara adat dan keagamaan;
                                                                                <br/> <br/>
                                                                                12. dan pos pengawas balawista.
                                                                            </div>
                                                                        : map_detail.NAMOBJ === 'Sempadan Sungai' ?
                                                                            <div style={{fontSize: 13}}>
                                                                                1. pemanfaatan untuk ruang terbuka hijau atau budidaya pertanian dengan jenis tanaman yang mendukung upaya pelestarian sempadan sungai;
                                                                                <br/>
                                                                                <br/>
                                                                                2. pembangunan infrastruktur jalan dan kelengkapannya;
                                                                                <br/>
                                                                                <br/>
                                                                                3. pemanfaatan untuk pemasangan reklame dan papan pengumuman; 
                                                                                <br/>
                                                                                <br/>
                                                                                4. pemanfaatan untuk pemasangan bentangan kabel listrik, kabel telepon, dan pipa air minum serta prasarana lalu lintas air;
                                                                                <br/>
                                                                                <br/>
                                                                                5. pemanfaatan untuk pemancangan tiang atau pondasi prasarana jalan dan jembatan; dan
                                                                                pembangunan dan dan kelengkapannya untuk menunjang pengelolaan sungai.
                                                                            </div>
                                                                        : null
                                                                    }
                                                                </>
                                                            : sub_element === 'bersyarat' ?
                                                                <>
                                                                    {/* <p style={{fontSize: 12, marginTop: 16, textTransform: 'uppercase'}}><ion-icon name="ellipse-outline" style={{fontSize: 14, marginBottom: -2, marginRight: 4}}></ion-icon> Bersyarat</p> */}
                                                                    {/* <div className="_push_t_m _cl_smooth_2">{map_detail.Bersyarat}</div> */}
                                                                    {
                                                                        map_detail.NAMOBJ === 'Badan Air' ?
                                                                            <div style={{fontSize: 13}}></div>
                                                                        : map_detail.NAMOBJ === 'Kawasan Ekosistem Mangrove' ?
                                                                            <div style={{fontSize: 13}}>kegiatan–kegiatan yang dapat mengurangi luas dan menyebabkan pencemaran ekosistem bakau</div>
                                                                        : map_detail.NAMOBJ === 'Kawasan Hortikultura' ?
                                                                            <div style={{fontSize: 13}}>
                                                                                1. pengembangan infrastruktur pendukung agribisnis dan agroindustri hortikultura;
                                                                                <br/><br/>
                                                                                2. fasilitas penunjang permukiman perdesaan, agrowisata dan ekowisata disertai usaha penyediaan akomodasi terbatas disekitarnya; dan
                                                                                <br/><br/>
                                                                                3. campuran dengan peruntukan tanaman pangan, perkebunan, peternakan, serta budidaya perikanan.
                                                                            </div>
                                                                        : map_detail.NAMOBJ === 'Kawasan Hutan Lindung' ?
                                                                            <div style={{fontSize: 13}}>
                                                                                1. pertambangan meliputi pertambangan mineral, batubara, minyak dan gas bumi termasuk sarana, prasarana, dan smelter;
                                                                                <br/><br/>
                                                                                2. instalasi pembangkit, transmisi, distribusi listrik dan gardu induk serta teknologi energi baru dan terbarukan;
                                                                                <br/><br/>
                                                                                3. panas bumi;
                                                                                <br/><br/>
                                                                                4. jaringan telekomunikasi, stasiun pemancar radio, dan stasiun relay televisi serta stasiun bumi pengamatan keantariksaan;
                                                                                <br/><br/>
                                                                                5. jalan umum, jalan tol, dan jalur kereta api;
                                                                                <br/><br/>
                                                                                6. waduk, bendungan, bendung, irigasi, saluran air minum, saluran pembuangan air dan sanitasi, dan bangunan pengairan lainnya;
                                                                                <br/><br/>
                                                                                7. fasilitas umum;
                                                                                <br/><br/>
                                                                                8. industri selain industri primer hasil hutan;
                                                                                <br/><br/>
                                                                                9. pertahanan dan keamanan, antara lain sarana dan prasarana latihan tempur, stasiun radar, dan menara pengintai, pos lintas batas negara (PLBN);
                                                                                <br/><br/>
                                                                                10. prasarana penunjang keselamatan umum antara lain keselamatan lalu lintas laut, lalu lintas udara, lalu lintas darat, karantina dan sarana meteorologi, klimatologi dan geofisika;
                                                                                <br/><br/>
                                                                                11. pembangunan bandar udara dan pelabuhan; dan
                                                                                <br/><br/>
                                                                                12. Tempat Pembuangan Akhir (TPA) sampah.
                                                                            </div>
                                                                        : map_detail.NAMOBJ === 'Kawasan Hutan Produksi Terbatas' ?
                                                                            <div style={{fontSize: 13}}>
                                                                                1. kegiatan pertambangan;
                                                                                <br/><br/>
                                                                                2. religi;
                                                                                <br/><br/>
                                                                                3. pembangunan instalasi pembangkit, transmisi, distribusi, dan teknologi energi/listrik baru dan terbarukan;
                                                                                <br/><br/>
                                                                                4. pembangunan jaringan telekomunikasi, stasiun pemancar radio, dan stasiun relay televisi;
                                                                                <br/><br/>
                                                                                5. pembangunan jalan umum; 
                                                                                <br/><br/>
                                                                                6. pembangunan sarana transportasi yang tidak dikategorikan sebagai sarana transportasi umum untuk keperluan pengangkutan hasil produksi;
                                                                                <br/><br/>
                                                                                7. pembangunan sarana dan prasarana sumber daya air, jaringan instalasi air, saluran air minum, saluran air limbah; 
                                                                                <br/><br/>
                                                                                8. pembangunan fasilitas umum;
                                                                                <br/><br/>
                                                                                9. pertahanan dan keamanan;
                                                                                <br/><br/>
                                                                                10. prasarana penunjang keselamatan umum; dan 
                                                                                <br/><br/>
                                                                                11. penampungan sementara korban bencana alam.
                                                                            </div>
                                                                        : map_detail.NAMOBJ === 'Kawasan Hutan Produksi Tetap' ?
                                                                            <div style={{fontSize: 13}}>
                                                                                1. industri pengolah hasil hutan
                                                                                <br/><br/>
                                                                                2. dan perkebunan.
                                                                                <br/><br/>
                                                                                kegiatan yang diperbolehkan dengan syarat, selain sebagaimana dimaksud pada huruf a dan b diluar kegiatan kehutanan, meliputi: 
                                                                                <br/><br/>
                                                                                1. kegiatan pertambangan;
                                                                                <br/><br/>
                                                                                2. religi;
                                                                                <br/><br/>
                                                                                3. pembangunan instalasi pembangkit, transmisi, distribusi, dan teknologi energi/listrik baru dan terbarukan;
                                                                                <br/><br/>
                                                                                4. pembangunan jaringan telekomunikasi, stasiun pemancar radio, dan stasiun relay televisi;
                                                                                <br/><br/>
                                                                                5. pembangunan jalan umum; 
                                                                                <br/><br/>
                                                                                6. pembangunan sarana transportasi yang tidak dikategorikan sebagai sarana transportasi umum untuk keperluan pengangkutan hasil produksi;
                                                                                <br/><br/>
                                                                                7. pembangunan sarana dan prasarana sumber daya air, jaringan instalasi air, saluran air minum, saluran air limbah; 
                                                                                <br/><br/>
                                                                                8. pembangunan fasilitas umum;
                                                                                <br/><br/>
                                                                                9. pertahanan dan keamanan;
                                                                                <br/><br/>
                                                                                10. prasarana penunjang keselamatan umum; dan 
                                                                                <br/><br/>
                                                                                11. penampungan sementara korban bencana alam.
                                                                            </div>
                                                                        : map_detail.NAMOBJ === 'Kawasan Perikanan Budi Daya' ?
                                                                            <div style={{fontSize: 13}}>
                                                                                1. membudidayakan jenis ikan baru;
                                                                                <br/><br/>
                                                                                2. membudidayakan jenis ikan yang dilindungi;
                                                                                <br/><br/>
                                                                                3. mengolah hasil perikanan;
                                                                                <br/><br/>
                                                                                4. pembuangan dan/atau pengaliran limbah dari kegiatan budidaya ikan ke lingkungan;
                                                                                <br/><br/>
                                                                                5. pengembangan minawisata;dan
                                                                            </div>
                                                                        : map_detail.NAMOBJ === 'Kawasan Perkebunan' ?
                                                                            <div style={{fontSize: 13}}>
                                                                                1. pengembangan infrastruktur pendukung agribisnis dan agroindustri perkebunan. Permukiman;
                                                                                <br/><br/>
                                                                                2. fasilitas penunjang permukiman perdesaan, agrowisata, ekowisata;
                                                                                <br/><br/>
                                                                                3. pariwisata aktif lainnya disertai usaha penyediaan akomodasi terbatas disekitarnya; 
                                                                                <br/><br/>
                                                                                4. pengembangan jaringan prasarana untuk kepentingan umum; dan
                                                                                <br/><br/>
                                                                                5. alih fungsi kawasan perkebunan menjadi fungsi lainnya dapat dilakukan sepanjang sesuai dan mengikuti ketentuan peraturan perundang-undangan yang berlaku.
                                                                            </div>
                                                                        : map_detail.NAMOBJ === 'Kawasan Permukiman Perdesaan' ?
                                                                            <div style={{fontSize: 13}}>
                                                                                a. aneka industri kecil dan menengah yang tidak mencemari lingkungan.
                                                                                <br/><br/>
                                                                                b. peribadatan  sesuai peraturan perundang-undangan;
                                                                                <br/><br/>
                                                                                c. akomodasi pariwisata dalam bentuk home stay dan penginapan kerakyatan; 
                                                                                <br/><br/>
                                                                                d. perdagangan dan jasa modern sesuai peraturan perundang-undangan.
                                                                                <br/><br/>
                                                                                e. peternakan rakyat dengan syarat tidak membiarkan ternak berkeliaran bebas serta kotoran dan limbah yang dihasilkan tidak mencemari lingkungan;
                                                                                <br/><br/>
                                                                                f. budidaya ikan dengan syarat tidak mencemari lingkungan; dan
                                                                                <br/><br/>
                                                                                g. pertambangan yang tidak menimbulkan dampak penting lingkungan.
                                                                            </div>
                                                                        : map_detail.NAMOBJ === 'Kawasan Permukiman Perkotaan' ?
                                                                            <div style={{fontSize: 13}}>
                                                                                a. akomodasi wisata non bintang dan tidak mengganggu fungsi kawasan permukiman;
                                                                                <br/><br/>
                                                                                b. aneka industri kecil dan menengah yang tidak mencemari lingkungan.
                                                                            </div>
                                                                        : map_detail.NAMOBJ === 'Kawasan Pertahanan dan Keamanan' ?
                                                                            <div style={{fontSize: 13}}>
                                                                                pemanfaatan ruang disekitar kawasan pertahanan dan keamanan dengan memperhatikan radius aman;
                                                                            </div>
                                                                        : map_detail.NAMOBJ === 'Kawasan Peruntukan Industri' ?
                                                                            <div style={{fontSize: 13}}>
                                                                                1. permukiman karyawan dalam kawasan;
                                                                                <br/><br/>
                                                                                2. fasilitas penunjang permukiman dan industri; 
                                                                                <br/><br/>
                                                                                3. aktvitas bongkar muat;
                                                                                <br/><br/>
                                                                                4. pengolahan limbah.
                                                                            </div>
                                                                        : map_detail.NAMOBJ === 'Kawasan Tanaman Pangan' ?
                                                                            <div style={{fontSize: 13}}>
                                                                                1. kegiatan pariwisata secara terbatas dengan konsep agrowisata, ekowisata dan desa wisata 
                                                                                <br/><br/>
                                                                                2. budidaya perikanan dengan konsep minapolitan;
                                                                                <br/><br/>
                                                                                3. pengalihfungsian lahan basah yang sudah ditetapkan sebagai Lahan Pertanian Pangan Berkelanjutan (LP2B) hanya dapat dilakukan untuk kepentingan umum dengan syarat dilakukan kajian kelayakan strategis, disusun rencana alih fungsi lahan, dibebaskan kepemilikan haknya dari pemilik dan disediakan lahan pengganti terhadap Lahan Pertanian Pangan Berkelanjutan yang dialihfungsikan; dan
                                                                                <br/><br/>
                                                                                4. penyediaan lahan pengganti terhadap Lahan Pertanian Pangan Berkelanjutan (LP2B) yang dialihfungsikan dilakukan atas dasar kesesuaian lahan, dengan ketentuan: 
                                                                                <br/><br/>
                                                                                a. paling sedikit tiga kali luas lahan dalam hal yang dialihfungsikan lahan beririgasi;
                                                                                <br/><br/>
                                                                                b. paling sedikit dua kali luas lahan dalam hal yang dialihfungsikan lahan reklamasi rawa pasang surut dan nonpasang surut (lebak); dan
                                                                                <br/><br/>
                                                                                c. paling sedikit satu kali luas lahan dalam hal yang dialihfungsikan lahan tidak beririgasi.
                                                                            </div>
                                                                        : map_detail.NAMOBJ === 'Sempadan Pantai' ?
                                                                            <div style={{fontSize: 13}}>
                                                                                1. asilitas penunjang rekreasi pantai <br/> <br/>
                                                                                2. fasilitas penunjang usaha penyediaan akomodasi <br/> <br/>
                                                                                3. bangunan struktur perlindungan pantai dan pengamanan pesisir <br/><br/>
                                                                                4. infrastruktur jalan dan jaringan pergerakan lainnya <br/> <br/>
                                                                                5. kepelabuhanan, kebandarudaraan <br/> <br/>
                                                                                6. jaringan infrastruktur wilayah <br/><br/>
                                                                                7. kegiatan pemangkalan perahu nelayan dan perahu wisata <br/><br/>
                                                                                8. bangunan dan kegiatan adat dan agama <br/> <br/>
                                                                                9. dan bangunan lain yang telah ada dan/atau bangunan yang telah memiliki izin.
                                                                            </div>
                                                                        : map_detail.NAMOBJ === 'Sempadan Sungai' ?
                                                                            <div style={{fontSize: 13}}>
                                                                                1. pengelolaan sampah, dengan sistem yang tidak mencemari lingkungan; 
                                                                                <br/>
                                                                                <br/>
                                                                                2. pengelolaan limbah padat dan/atau cair, dengan sistem yang tidak mencemari lingkungan; dan
                                                                                <br/>
                                                                                <br/>
                                                                                3. pembangunan gedung penunjang pengendalian tata air.
                                                                                <br/>
                                                                                <br/>
                                                                                4. pendirian bangunan di batasi hanya untuk menunjang fungsi taman rekreasi dan/atau joging track tepi sungai secara menarik; dan
                                                                                <br/>
                                                                                <br/>
                                                                                5. kegiatan pertambangan bahan galian golongan c dan golongan lainnya di sungai dengan syarat tidak mengganggu fungsi konservasi air dan kegiatan budidaya lainnya dan serta telah memiliki izin dari instansi berwenang
                                                                            </div>
                                                                        : null
                                                                    }
                                                                </>
                                                            : sub_element === 'tidakdiperbolehkan' ?
                                                                <>
                                                                    {/* <p style={{fontSize: 12, marginTop: 16, textTransform: 'uppercase'}}><ion-icon name="ellipse-outline" style={{fontSize: 14, marginBottom: -2, marginRight: 4}}></ion-icon> Tidak Diperbolehkan</p> */}
                                                                    {/* <div className="_push_t_m _cl_smooth_2">{map_detail.Tidak_Dipe}</div> */}
                                                                    {
                                                                        map_detail.NAMOBJ === 'Badan Air' ?
                                                                            <div style={{fontSize: 13}}></div>
                                                                        : map_detail.NAMOBJ === 'Kawasan Ekosistem Mangrove' ?
                                                                            <div style={{fontSize: 13}}>
                                                                                kegiatan yang berpotensi mengurangi luas atau mengalih fungsikan kawasan ekosistem mangrove.
                                                                            </div>
                                                                        : map_detail.NAMOBJ === 'Kawasan Hortikultura' ?
                                                                            <div style={{fontSize: 13}}>
                                                                                1. permukiman perkotaan atau permukiman perdesaan intensif;
                                                                                <br/><br/>
                                                                                2. kegiatan pendirian bangunan selain bangunan penunjang kegiatan sebagaimana dimaksud pada huruf a dan hurufb yang mengganggu fungsi kawasan pertanian hortikultura.
                                                                            </div>
                                                                        : map_detail.NAMOBJ === 'Kawasan Hutan Lindung' ?
                                                                            <div style={{fontSize: 13}}>
                                                                                1. merusak/membakar komponen hutan dan ekosistemnya, memotong kayu atau vegetasi hutan;
                                                                                <br/><br/>
                                                                                2. meninggalkan / membuang sampah atau barang–barang lainnya yang mengganggu kelestarian hutan; dan
                                                                                <br/><br/>
                                                                                3. pemanfaatan hutan, yang bersifat menggunakan peralatan mekanis dan alat berat, membangun sarana dan prasarana permanen, mengganggu fungsi kawasan, penebangan pohon, menggunakan pestisida dan insektisida, melakukan kegiatan pada kelerengan di atas 25% (dua puluh lima persen).
                                                                            </div>
                                                                        : map_detail.NAMOBJ === 'Kawasan Hutan Produksi Terbatas' ?
                                                                            <div style={{fontSize: 13}}>
                                                                                1. kegiatan industri;
                                                                                <br/><br/>
                                                                                2. kegiatan berburu binatang;
                                                                                <br/><br/>
                                                                                3. penebangan pohon dan pengambilan hasil hutan tanpa izin dari pihak yang berwenang;
                                                                                <br/><br/>
                                                                                4. kegiatan lainnya yang tidak sesuai dengan ketentuan kawasan hutan produksi tetap.
                                                                            </div>
                                                                        : map_detail.NAMOBJ === 'Kawasan Hutan Produksi Tetap' ?
                                                                            <div style={{fontSize: 13}}>
                                                                                1. penebangan pohon dan pengambilan hasil hutan tanpa izin dari pihak yang berwenang;
                                                                                <br/><br/>
                                                                                2. dan kegiatan lainnya yang tidak sesuai dengan ketentuan kawasan hutan produksi terbatas.
                                                                            </div>
                                                                        : map_detail.NAMOBJ === 'Kawasan Perikanan Budi Daya' ?
                                                                            <div style={{fontSize: 13}}>
                                                                                1. membudidayakan ikan yang dapat membahayakan sumber daya ikan serta lingkungan sumber daya ikan dan/atau kesehatan manusia;
                                                                                <br/><br/>
                                                                                2. membudidayakan ikan hasil rekayasa genetika yang dapat membahayakan sumber daya ikan serta lingkungan sumber daya ikan dan/atau kesehatan manusia; dan
                                                                                <br/><br/>
                                                                                3. menggunakanobat-obatan dalam pembudidayaan ikan yang dapat membahayakan sumber daya ikan serta lingkungan sumber daya ikan dan/atau kesehatan manusia.
                                                                            </div>
                                                                        : map_detail.NAMOBJ === 'Kawasan Perkebunan' ?
                                                                            <div style={{fontSize: 13}}>
                                                                                1. permukiman perkotaan atau permukiman perdesaan intensif; dan
                                                                                <br/><br/>
                                                                                2. pendirian bangunan selain bangunan penunjang kegiatan sebagaimana dimaksud pada huruf a dan huruf b yang mengganggu fungsi kawasan budidaya perkebunan.
                                                                            </div>
                                                                        : map_detail.NAMOBJ === 'Kawasan Permukiman Perdesaan' ?
                                                                            <div style={{fontSize: 13}}>
                                                                                a. industri berat dan industri yang menimbulkan polusi
                                                                                <br/><br/>
                                                                                b. pusat perbelanjaan dan toko modern skala besar.
                                                                            </div>
                                                                        : map_detail.NAMOBJ === 'Kawasan Permukiman Perkotaan' ?
                                                                            <div style={{fontSize: 13}}>
                                                                                a. pertambangan;
                                                                                <br/><br/>
                                                                                b. industri berat dan/atau industri yang berpotensi menimbulkan pencemaran lingkungan hidup yang berdampak luas.
                                                                            </div>
                                                                        : map_detail.NAMOBJ === 'Kawasan Pertahanan dan Keamanan' ?
                                                                            <div style={{fontSize: 13}}>
                                                                                kegiatan budidaya yang dapat merubah dan/atau mengganggu fungsi utama kawasan pertahanan dan keamanan.
                                                                            </div>
                                                                        : map_detail.NAMOBJ === 'Kawasan Peruntukan Industri' ?
                                                                            <div style={{fontSize: 13}}>
                                                                                1. kegiatan penimbunan yang membahayakan keselamatan dan kesehatan kerja.
                                                                                <br/><br/>
                                                                                2. lokasi kawasan peruntukan industri tidak diperbolehkan berbatasan langsung dengan kawasanpermukiman;
                                                                            </div>
                                                                        : map_detail.NAMOBJ === 'Kawasan Tanaman Pangan' ?
                                                                            <div style={{fontSize: 13}}>
                                                                                1. alih fungsi lahan pertanian pangan yang telah ditetapkan sebagai lahan pangan berkelanjutan selain sebagaimana dimaksud pada huruf b angka 3 untuk kepentingan umum; dan
                                                                                <br/><br/>
                                                                                2. kegiatan pendirian bangunan selain bangunan penunjang kegiatan sebagaimana dimaksud pada huruf a yang mengganggu fungsi kawasan pertanian tanaman pangan.
                                                                            </div>
                                                                        : map_detail.NAMOBJ === 'Sempadan Pantai' ?
                                                                            <div style={{fontSize: 13}}>
                                                                                kegiatan yang dapat mengancam/ mengganggu/tidak selaras dengan esensi fungsi penetapan batas sempadan pantai, mencakup; <br/><br/>
                                                                                1. pendirian bangunan selain yang diatur dalam ketentuan yang diperbolehkan dan yang diperbolehkan dengan syarat; <br/><br/>
                                                                                2. dan kegiatan yang dapat menurunkan kualitas atau merusak sumberdaya alam dan ekosistem wilayah pesisir.
                                                                            </div>
                                                                        : map_detail.NAMOBJ === 'Sempadan Sungai' ?
                                                                            <div style={{fontSize: 13}}>
                                                                                mencakup semua kegiatan di luar kegiatan sebagaimana dimaksud huruf a dan huruf b, termasuk pembuangan sampah, pembuangan limbah padat dan/atau cair;
                                                                            </div>
                                                                        : null
                                                                    }
                                                                </>
                                                            : null
                                                        }

                                                    </>
                                                }
                                                
                                                {/* <div className="_row _center_align _push_t_m">
                                                    <div className="_column _center_text _cursor_pointer">
                                                        <div style={{borderWidth: 1, borderColor: '#eee', borderStyle: 'solid', padding: 8}}>
                                                            Pola Ruang
                                                        </div>
                                                    </div>
                                                    <div className="_column _center_text _cursor_pointer">
                                                        <div style={{borderWidth: 1, borderColor: '#eee', borderStyle: 'solid', padding: 8}}>
                                                            Intensitas
                                                        </div>
                                                    </div>
                                                    <div className="_column _center_text _cursor_pointer">
                                                        <div style={{borderWidth: 1, borderColor: '#eee', borderStyle: 'solid', padding: 8}}>
                                                            Kegiatan
                                                        </div>
                                                    </div>
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>
                                : null
                            : null
                        }
                </div>

            </div>
            
             {/*  Documentation ------------------------------------------------------------- */}

                {/* <div className="_row _center_align">
                    <div className="_column">

                    </div>
                    <div className="_column">
                        
                    </div>
                </div> */}

                {/* <div onClick={() => {
                    if(element === 'overlay'){
                        set_element(null)
                    }else{
                        set_element('overlay')
                    }
                }} className="_btn _cursor_pointer">
                    fmc overlay btn
                </div>

                {
                    element === 'overlay' ?
                        <>
                            <div className="_fmc_overlay">
                                <div className="_fmc_overlay_navbar">
                                    <div className="_row _center_align">
                                        <div className="_column">
                                            <p className="_font_size_18px">Overlay</p>
                                        </div>
                                        <div onClick={() => {
                                            if(element === 'overlay'){
                                                set_element(null)
                                            }else{
                                                set_element('overlay')
                                            }
                                        }} className="_push_l_d _btn _cursor_pointer">
                                            Keluar
                                        </div>
                                    </div>
                                </div>
                                <div className="_fmc_overlay_content">

                                </div>
                            </div>
                        </>
                    : null
                }

                <div className="_relative">
                    <div onClick={() => {
                        if(element === 'overlay_dropdown'){
                            set_element(null)
                        }else{
                            set_element('overlay_dropdown')
                        }
                    }} className="_btn _cursor_pointer">
                        <div className="_row _center_align">
                            <div className="_column">
                                fmc overlay dropdown btn
                            </div>
                            <div className="_push_l_m _push_t_t">
                                {
                                    element === 'overlay_dropdown' ?
                                        <ion-icon name="chevron-up-outline"></ion-icon>
                                    :
                                        <ion-icon name="chevron-down-outline"></ion-icon>
                                }
                            </div>
                        </div>
                    </div>
                    {
                        element === 'overlay_dropdown' ?
                            // _left or _right
                            <>
                                <div className="_fmc_overlay_dropdown _left">
                                    <div onClick={() => {}} className="_item">1. oke</div>
                                    <div onClick={() => {}} className="_item">1. oke</div>
                                    <div onClick={() => {}} className="_item">1. oke</div>
                                    <div onClick={() => {}} className="_item">1. oke</div>
                                </div>
                            </>
                        : null
                    }
                </div>

                <div className="_relative _push_b_m">
                    <p style={{color: '#888', fontSize: 13}}>
                        <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                        Input
                    </p>
                    <div className="_e_input">
                        <input 
                            placeholder=""
                            type={'text'} 
                            // onChange={e => set_input(e.target.value)}
                            // value={input}
                        />
                    </div>
                </div>

                <div className="_bb-input" style={{paddingBottom: 10, paddingTop: 10}}>
                                        
                    <input
                        className="custom-file-input" 
                        type="file"
                        name="file"
                        placeholder=""
                        onChange={_files}
                    />

                </div>

                <div onClick={() => {
                    _uploads()
                }} className="_btn _cursor_pointer">
                    Simpan
                </div>

                <div className="_bb_search" style={{backgroundColor: 'transparent'}}>
                    <div className="_row _center_align">
                        <ion-icon name="search-outline" style={{fontSize: 20}}></ion-icon>
                        <div className="_column">
                            <input 
                                placeholder="Cari" 
                                onChange={e => set_search(e.target.value)}
                                value={search}
                            />
                        </div>
                    </div>
                </div>

                <div className="_overflow_x">
                    <table className="_table">
                        <thead>
                            <th style={{width: 60}}><ion-icon name="rocket-outline" style={{fontSize: 22}}></ion-icon></th>
                            <th>Title</th>
                            <th>Description</th>
                            <th>Category</th>
                            <th>
                                <div className="_right_text">
                                    <ion-icon name="magnet-outline" style={{fontSize: 24}}></ion-icon>
                                </div>
                            </th>
                        </thead>
                        <tbody>
                            <tr>
                                <td colSpan="5"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                
                <div className="_lily_pad_h_d _push_b_d _push_t_d">
                    <div className="__pagination">
                        {
                            data&&data.pages.map((item, index) => {
                                if(data.pages.length > 1){
                                    return (

                                        <div 
                                            key={index} 
                                            className="__item"
                                            style={{backgroundColor: pagination_active === index + 1 ? '#eee' : '#fff'}}
                                            onClick={() => {
                                                _read(index + 1);
                                                set_pagination_active(index + 1)
                                            }}
                                        >
                                            <div className="_position_middle">
                                                {item}
                                            </div>
                                        </div>
                                        
                                    )
                                }
                            })
                        }
                    </div>
                </div> */}

                {/* <NavLink 
                    to='/sims/export/rapor'
                    className="_btn _cursor_pointer"
                >
                    Export PDF
                </NavLink> */}
                
            {/*  End Documentation --------------------------------------------------------- */}
            
            {/*  Stuck --------------------------------------------------------------------- */}
            {/* <div style={{height: 100}}></div> */}
            {/*  End Stuck ----------------------------------------------------------------- */}

        </>
    );

}

export default Screen;